<template>
  <div class="ehsgismapwrap" id="ehsGisMapWrap">
    <div class="ehstab">
      <el-tabs v-model="homeTypeTab" @tab-click="addGraphics('stations')" stretch>
        <el-tab-pane label="  总览  " name="map"></el-tab-pane>
        <el-tab-pane label="  大气  " name="atmos"></el-tab-pane>
        <el-tab-pane label="  水质  " name="water"></el-tab-pane>
        <el-tab-pane label="  用电  " name="uelectro"></el-tab-pane>
        <el-tab-pane label="  用水  " name="uwater"></el-tab-pane>
      </el-tabs>
    </div>
    <div class="gismapdivcenter">
      <div v-bind:class="{ 'rightdiv':hideRightDiv,'rightside':!hideRightDiv}">
        <div class="menu">
          <div class="listheader">
            <!-- <div class="markListTitle"> -->
            <div class="listTitle">
              <el-button class="listHideBtn" type="primary" @click="hideRightDiv=!hideRightDiv"></el-button>
              <div class="markListTitle">站点列表</div>
              <el-button class="modeChangeBtn mnticon" type="primary" @click="modeChange" v-if="subTypeMode!=='monitors'"></el-button>
              <el-button class="modeChangeBtn listicon" type="primary" @click="modeChange" v-else></el-button>
            </div>
            <!-- </div> -->
            <div class="markSearch">
              <el-button type="primary" class="markFilterbtn" @click="showFilterForm = !showFilterForm"></el-button>
              <el-input class="searchinput" clearable placeholder="输入关键字查找" v-model="markerSearch" @clear="addGraphics('stations')"></el-input>
              <el-button type="primary" class="markSearchbtn" @click="addGraphics('stations')"></el-button>
            </div>
            <div class="filterForm" v-show="showFilterForm">
              <div class="filterreset">
                <el-button type="primary" @click="filterblue = false, filtergreen = false, filteryellow = false, filterred = false, filterblack = false, addGraphics('stations')">
                  <p>清空</p>
                  <p>筛选</p>
                </el-button>
              </div>
              <div v-bind:class="{ 'filtercolor':!filtergreen, 'filtercolord':filtergreen}" id="filtergreen" @click="filtergreen = !filtergreen, addGraphics('stations')" ></div>
              <div v-bind:class="{ 'filtercolor':!filteryellow, 'filtercolord':filteryellow}" id="filteryellow" @click="filteryellow = !filteryellow, addGraphics('stations')" ></div>
              <div v-bind:class="{ 'filtercolor':!filterred, 'filtercolord':filterred}" id="filterred" @click="filterred = !filterred, addGraphics('stations')" ></div>
              <div v-bind:class="{ 'filtercolor':!filterblue, 'filtercolord':filterblue}" id="filterblue" @click="filterblue = !filterblue, addGraphics('stations')" ></div>
              <div v-bind:class="{ 'filtercolor':!filterblack, 'filtercolord':filterblack}" id="filterblack" @click="filterblack = !filterblack, addGraphics('stations')" ></div>
            </div>
          </div>
          <div :class="{
            'markList mlDefault': !showFilterForm && !mapFullScreenFlag,
            'markList mlShowFilter': showFilterForm && !mapFullScreenFlag,
            'markList mlFullScreen': !showFilterForm && mapFullScreenFlag,
            'markList mlFullScreenShowFilter': showFilterForm && mapFullScreenFlag,
            }">
            <!-- areaIntros -->
            <div v-if="subTypeMode !== 'monitors'">
              <div class="markCard-areaIntros"
                v-for="(markerDataMarker, index) in markerDataMntList"
                :key="index"
                @click="clickMarker(markerDataMarker)">
                <div class="markerData">
                  <div class="markerMarker">
                    <div
                      :class="{
                        'markerType mapiconblue':markerDataMarker.mntType=='map'&&markerDataMarker.markerData.markerType==1,
                        'markerType mapicongreen':markerDataMarker.mntType=='map'&&markerDataMarker.markerData.markerType==2,
                        'markerType mapiconyellow':markerDataMarker.mntType=='map'&&markerDataMarker.markerData.markerType==3,
                        'markerType mapiconred':markerDataMarker.mntType=='map'&&markerDataMarker.markerData.markerType==4,
                        'markerType mapiconblack':markerDataMarker.mntType=='map'&&markerDataMarker.markerData.markerType==0,
                        'markerType atmosiconblue':markerDataMarker.mntType=='atmos'&&markerDataMarker.markerData.markerType==1,
                        'markerType atmosicongreen':markerDataMarker.mntType=='atmos'&&markerDataMarker.markerData.markerType==2,
                        'markerType atmosiconyellow':markerDataMarker.mntType=='atmos'&&markerDataMarker.markerData.markerType==3,
                        'markerType atmosiconred':markerDataMarker.mntType=='atmos'&&markerDataMarker.markerData.markerType==4,
                        'markerType atmosiconblack':markerDataMarker.mntType=='atmos'&&markerDataMarker.markerData.markerType==0,
                        'markerType watericonblue':markerDataMarker.mntType=='water'&&markerDataMarker.markerData.markerType==1,
                        'markerType watericongreen':markerDataMarker.mntType=='water'&&markerDataMarker.markerData.markerType==2,
                        'markerType watericonyellow':markerDataMarker.mntType=='water'&&markerDataMarker.markerData.markerType==3,
                        'markerType watericonred':markerDataMarker.mntType=='water'&&markerDataMarker.markerData.markerType==4,
                        'markerType watericonblack':markerDataMarker.mntType=='water'&&markerDataMarker.markerData.markerType==0,
                        'markerType uelectroiconblue':markerDataMarker.mntType=='uelectro'&&markerDataMarker.markerData.markerType==1,
                        'markerType uelectroicongreen':markerDataMarker.mntType=='uelectro'&&markerDataMarker.markerData.markerType==2,
                        'markerType uelectroiconyellow':markerDataMarker.mntType=='uelectro'&&markerDataMarker.markerData.markerType==3,
                        'markerType uelectroiconred':markerDataMarker.mntType=='uelectro'&&markerDataMarker.markerData.markerType==4,
                        'markerType uelectroiconblack':markerDataMarker.mntType=='uelectro'&&markerDataMarker.markerData.markerType==0,
                        'markerType uwatericonblue':markerDataMarker.mntType=='uwater'&&markerDataMarker.markerData.markerType==1,
                        'markerType uwatericongreen':markerDataMarker.mntType=='uwater'&&markerDataMarker.markerData.markerType==2,
                        'markerType uwatericonyellow':markerDataMarker.mntType=='uwater'&&markerDataMarker.markerData.markerType==3,
                        'markerType uwatericonred':markerDataMarker.mntType=='uwater'&&markerDataMarker.markerData.markerType==4,
                        'markerType uwatericonblack':markerDataMarker.mntType=='uwater'&&markerDataMarker.markerData.markerType==0,
                      }"
                      @click="clickMarkerDetails(markerDataMarker)"></div>
                  </div>
                  <div class="markerMain">
                    <div class="markerName">{{ markerDataMarker.markerData.markerName }}</div>
                    <div class="markerOthers">
                      <span class="markerTime" v-if="'eqmTime' in markerDataMarker.eqmData">{{ markerDataMarker.eqmData.eqmTime }}</span>
                      <span class="markerTarget" v-if="'maxRatioItem' in markerDataMarker.eqmData">{{ markerDataMarker.eqmData.maxRatioItem.idName }} {{ markerDataMarker.eqmData.maxRatioItem.value }}{{ markerDataMarker.eqmData.maxRatioItem.unit}}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- /areaIntros -->
            <!-- monitors -->
            <div v-if="subTypeMode == 'monitors'">
              <div class="markCard-monitors"
                v-for="(markerDataMarker, index) in markerDataMntList"
                :key="index"
                @click="clickMarker(markerDataMarker)">
                <div class="markerData">
                  <div class="markerMarker-monitor" :span="2">
                    <div
                      :class="{
                        'markerType-monitor mapiconblue':markerDataMarker.mntType=='map'&&markerDataMarker.markerData.markerType==1,
                        'markerType-monitor mapicongreen':markerDataMarker.mntType=='map'&&markerDataMarker.markerData.markerType==2,
                        'markerType-monitor mapiconyellow':markerDataMarker.mntType=='map'&&markerDataMarker.markerData.markerType==3,
                        'markerType-monitor mapiconred':markerDataMarker.mntType=='map'&&markerDataMarker.markerData.markerType==4,
                        'markerType-monitor mapiconblack':markerDataMarker.mntType=='map'&&markerDataMarker.markerData.markerType==0,
                        'markerType-monitor atmosiconblue':markerDataMarker.mntType=='atmos'&&markerDataMarker.markerData.markerType==1,
                        'markerType-monitor atmosicongreen':markerDataMarker.mntType=='atmos'&&markerDataMarker.markerData.markerType==2,
                        'markerType-monitor atmosiconyellow':markerDataMarker.mntType=='atmos'&&markerDataMarker.markerData.markerType==3,
                        'markerType-monitor atmosiconred':markerDataMarker.mntType=='atmos'&&markerDataMarker.markerData.markerType==4,
                        'markerType-monitor atmosiconblack':markerDataMarker.mntType=='atmos'&&markerDataMarker.markerData.markerType==0,
                        'markerType-monitor watericonblue':markerDataMarker.mntType=='water'&&markerDataMarker.markerData.markerType==1,
                        'markerType-monitor watericongreen':markerDataMarker.mntType=='water'&&markerDataMarker.markerData.markerType==2,
                        'markerType-monitor watericonyellow':markerDataMarker.mntType=='water'&&markerDataMarker.markerData.markerType==3,
                        'markerType-monitor watericonred':markerDataMarker.mntType=='water'&&markerDataMarker.markerData.markerType==4,
                        'markerType-monitor watericonblack':markerDataMarker.mntType=='water'&&markerDataMarker.markerData.markerType==0,
                        'markerType-monitor uelectroiconblue':markerDataMarker.mntType=='uelectro'&&markerDataMarker.markerData.markerType==1,
                        'markerType-monitor uelectroicongreen':markerDataMarker.mntType=='uelectro'&&markerDataMarker.markerData.markerType==2,
                        'markerType-monitor uelectroiconyellow':markerDataMarker.mntType=='uelectro'&&markerDataMarker.markerData.markerType==3,
                        'markerType-monitor uelectroiconred':markerDataMarker.mntType=='uelectro'&&markerDataMarker.markerData.markerType==4,
                        'markerType-monitor uelectroiconblack':markerDataMarker.mntType=='uelectro'&&markerDataMarker.markerData.markerType==0,
                        'markerType-monitor uwatericonblue':markerDataMarker.mntType=='uwater'&&markerDataMarker.markerData.markerType==1,
                        'markerType-monitor uwatericongreen':markerDataMarker.mntType=='uwater'&&markerDataMarker.markerData.markerType==2,
                        'markerType-monitor uwatericonyellow':markerDataMarker.mntType=='uwater'&&markerDataMarker.markerData.markerType==3,
                        'markerType-monitor uwatericonred':markerDataMarker.mntType=='uwater'&&markerDataMarker.markerData.markerType==4,
                        'markerType-monitor uwatericonblack':markerDataMarker.mntType=='uwater'&&markerDataMarker.markerData.markerType==0,
                      }"
                      @click="clickMarkerDetails(markerDataMarker)"></div>
                  </div>
                  <div class="markerMain-monitor">
                    <div class="markerName">{{ markerDataMarker.markerData.markerName }}</div>
                  </div>
                </div>
                <div class="markerVideoPlayer" v-if="showVideoPlayer&&markerDataMarker.mntVideo.videoSrc&&markerDataMarker.mntVideo.videoType==='flv'">
                  <!-- <videoPlayer ref="playerObj" :videoSrc="markerDataMarker.mntVideo.videoSrc" :videoType="markerDataMarker.mntVideo.videoType"></videoPlayer> -->
                  <video class="myMntVideo" :id="'mntVideo' + markerDataMarker.order" controls autoplay muted></video>
                </div>
                <div class="markerVideoPlayer" v-else>
                  <div class="myMntVideoUdf">
                    <i class="el-icon-warning"></i> 缺少监控地址
                  </div>
                </div>
              </div>
            </div>
            <!-- /monitors -->
          </div>
        </div>
      </div>
      <div class="arcgis-map-div" id="arcgisMapDiv">
        <div class="arcgis-map" id="mapView"></div>
        <div class="arcgis-timeslider" id="timeSliderView"></div>
      </div>
    </div>
    <div class="measurementBar" id="topbarMeasure">
      <button
        class="action-button esri-icon-measure-line"
        id="distanceButton"
        type="button"
        title="测距离"
      ></button><br>
      <button
        class="action-button esri-icon-measure-area"
        id="areaButton"
        type="button"
        title="测面积"
      ></button>
    </div>
    <div class="provinceList" id="provinceListBar2D">
      <select v-model="mapProvinceActive" placeholder="请选择" @change="provinceChange()">
        <option v-for="(item, index) in mapProvinceList" :key="index" :label="item" :value="item"></option>
      </select>
    </div>
    <div class="provinceList" id="provinceListBar3D">
      <select v-model="mapProvinceActive" placeholder="请选择" @change="provinceChange()">
        <option v-for="(item, index) in mapProvinceList" :key="index" :label="item" :value="item"></option>
      </select>
    </div>
    <nut-dialog
      v-if="showSelectObjTypeFlag"
      :visible="showSelectObjTypeFlag"
      title="新增类型选择"
      :noFooter="true">
      <div style="text-align: center;">
        <el-button @click="selectObjType('objArea')" size="medium">新增区域</el-button>
        <el-button @click="selectObjType('building')" size="medium">新增建筑物</el-button>
      </div>
    </nut-dialog>
    <nut-dialog
      @close="showDetailsAtmos = false"
      v-if="showDetailsAtmos"
      :visible="showDetailsAtmos"
      title="大气站点详情"
      :noFooter="true">
      <ehsEQMAtmos :markerOrder="eqmMntOrder"></ehsEQMAtmos>
    </nut-dialog>
    <nut-dialog
      @close="showDetailsWater = false"
      v-if="showDetailsWater"
      :visible="showDetailsWater"
      title="水质站点详情"
      :noFooter="true">
      <ehsEQMWater :markerOrder="eqmMntOrder" :waterClass="eqmClass"></ehsEQMWater>
    </nut-dialog>
    <nut-dialog
      @close="showDetailsUelectro = false"
      v-if="showDetailsUelectro"
      :visible="showDetailsUelectro"
      title="用电站点详情"
      :noFooter="true">
      <ehsEQMUelectro :markerOrder="eqmMntOrder"></ehsEQMUelectro>
    </nut-dialog>
    <nut-dialog
      @close="showDetailsUwater = false"
      v-if="showDetailsUwater"
      :visible="showDetailsUwater"
      title="用水站点详情"
      :noFooter="true">
      <ehsEQMUwater :markerOrder="eqmMntOrder"></ehsEQMUwater>
    </nut-dialog>
    <nut-dialog
      @close="showMarkerDataSetter = false"
      v-if="showMarkerDataSetter"
      :visible="showMarkerDataSetter"
      title="设置点位基础信息"
      :noFooter="true">
      <nut-textinput
        label="点位名称"
        v-model="markerDataSetter.markerData.markerName">
      </nut-textinput>
      <nut-textinput
        label="点位经度"
        v-model="markerDataSetter.markerData.markerPosLng"
        @keyup.native="markerPosLngZ($event)">
      </nut-textinput>
      <nut-textinput
        label="点位纬度"
        v-model="markerDataSetter.markerData.markerPosLat"
        @keyup.native="markerPosLatZ($event)">
      </nut-textinput>
      <div>点位类型
        <select class="longSelect" v-model="markerDataSetter.mntType" placeholder="请选择">
          <!-- <option label="默认" value="map"></option> -->
          <option label="大气" value="atmos"></option>
          <option label="水质" value="water"></option>
          <option label="用电" value="uelectro"></option>
          <option label="用水" value="uwater"></option>
        </select>
      </div>
      <!-- <div v-if="markerDataSetter.mntType === 'atmos'">浓度限值
        <select class="longSelect" v-model="markerDataSetter.eqmData.atmosClass" placeholder="请选择">
          <option label="一级" value="一级"></option>
          <option label="二级" value="二级"></option>
        </select>
      </div>
      <div v-if="markerDataSetter.mntType === 'water'">水域分类
        <select class="longSelect" v-model="markerDataSetter.eqmData.waterClass" placeholder="请选择">
          <option label="I" value="i"></option>
          <option label="II" value="ii"></option>
          <option label="III" value="iii"></option>
          <option label="IV" value="iv"></option>
          <option label="V" value="v"></option>
        </select>
      </div> -->
      <nut-textinput
        label="监控地址"
        v-model="markerDataSetter.mntVideo.videoSrc">
      </nut-textinput>
      <!-- <nut-textinput
        label="监测数据地址"
        v-model="markerDataSetter.mntDataSrc">
      </nut-textinput> -->
      <nut-textinput
        label="设备标识"
        v-model="markerDataSetter.mntDataMN">
      </nut-textinput>
      <nut-textinput
        label="访问密码"
        v-model="markerDataSetter.mntDataPW">
      </nut-textinput>
      <div>所属地区
        <select class="longSelect" v-model="mapProvinceActive" placeholder="请选择">
          <option v-for="(item, index) in mapProvinceList" :key="index" :label="item" :value="item"></option>
        </select>
      </div>
      <div style="text-align: center;">
        <el-button @click="createMarkerData()" size="medium" type="primary">确认</el-button>
      </div>
    </nut-dialog>
    <nut-dialog
      @close="showMarkerDataEditor = false"
      v-if="showMarkerDataEditor"
      :visible="showMarkerDataEditor"
      title="编辑点位基础信息"
      :noFooter="true">
      <nut-textinput
        label="点位名称"
        v-model="markerDataSetter.markerData.markerName">
      </nut-textinput>
      <nut-textinput
        label="点位经度"
        v-model="markerDataSetter.markerData.markerPosLng"
        @keyup.native="markerPosLngZ($event)">
      </nut-textinput>
      <nut-textinput
        label="点位纬度"
        v-model="markerDataSetter.markerData.markerPosLat"
        @keyup.native="markerPosLatZ($event)">
      </nut-textinput>
      <div>点位类型
        <select class="longSelect" v-model="markerDataSetter.mntType" placeholder="请选择">
          <!-- <option label="默认" value="map"></option> -->
          <option label="大气" value="atmos"></option>
          <option label="水质" value="water"></option>
          <option label="用电" value="uelectro"></option>
          <option label="用水" value="uwater"></option>
        </select>
      </div>
      <!-- <div v-if="markerDataSetter.mntType === 'atmos'">浓度限值
        <select class="longSelect" v-model="markerDataSetter.eqmData.atmosClass" placeholder="请选择">
          <option label="一级" value="一级"></option>
          <option label="二级" value="二级"></option>
        </select>
      </div>
      <div v-if="markerDataSetter.mntType === 'water'">水域分类
        <select class="longSelect" v-model="markerDataSetter.eqmData.waterClass" placeholder="请选择">
          <option label="I" value="i"></option>
          <option label="II" value="ii"></option>
          <option label="III" value="iii"></option>
          <option label="IV" value="iv"></option>
          <option label="V" value="v"></option>
        </select>
      </div> -->
      <nut-textinput
        label="监控视频地址"
        v-model="markerDataSetter.mntVideo.videoSrc">
      </nut-textinput>
      <!-- <nut-textinput
        label="监测数据地址"
        v-model="markerDataSetter.mntDataSrc">
      </nut-textinput> -->
      <nut-textinput
        label="设备标识"
        v-model="markerDataSetter.mntDataMN">
      </nut-textinput>
      <nut-textinput
        label="访问密码"
        v-model="markerDataSetter.mntDataPW">
      </nut-textinput>
      <div>所属地区
        <select class="longSelect" v-model="mapProvinceActive" placeholder="请选择">
          <option v-for="(item, index) in mapProvinceList" :key="index" :label="item" :value="item"></option>
        </select>
      </div>
      <div style="text-align: center;">
        <el-button @click="editMarkerData" size="medium" type="primary">确认</el-button>
      </div>
    </nut-dialog>
    <nut-dialog
      v-if="showCreateObjAreaFlag"
      :visible="showCreateObjAreaFlag"
      title="设置区域数据"
      :noFooter="true">
      <el-form
        :model="objAreaDataSetter"
        label-width="120px">
        <nut-textinput
          prop="name"
          label="区域颜色">
          <div :span="16">
            <divor-picker v-model="objAreaDataSetter.colorName"></divor-picker>
          </div>
        </nut-textinput>
        <nut-textinput
          prop="province"
          label="所属地区">
          <div :span="16">
            <el-select v-model="mapProvinceActive">
              <option v-for="(item, index) in mapProvinceList" :key="index" :label="item" :value="item"></option>
            </el-select>
          </div>
        </nut-textinput>
      </el-form>
      <div style="text-align: center;">
        <el-button @click="createObjAreaData" size="medium" type="primary">确认</el-button>
      </div>
    </nut-dialog>
    <nut-dialog
      v-if="showCreateBuildingFlag"
      :visible.sync="showCreateBuildingFlag"
      title="设置建筑物数据"
      :noFooter="true">
      <el-form
        :model="buildingDataSetter"
        label-width="120px">
        <nut-textinput
          prop="name"
          label="建筑高度">
          <div :span="16">
            <el-input v-model="buildingDataSetter.height" placeholder="默认50"></el-input>
          </div>
        </nut-textinput>
        <nut-textinput
          prop="name"
          label="建筑颜色">
          <div :span="16">
            <divor-picker v-model="buildingDataSetter.colorName"></divor-picker>
          </div>
        </nut-textinput>
        <nut-textinput
          prop="province"
          label="所属地区">
          <div :span="16">
            <el-select v-model="mapProvinceActive">
              <option v-for="(item, index) in mapProvinceList" :key="index" :label="item" :value="item"></option>
            </el-select>
          </div>
        </nut-textinput>
      </el-form>
      <div style="text-align: center;">
        <el-button @click="createBuildingData" size="medium" type="primary">确认</el-button>
      </div>
    </nut-dialog>
    <nut-dialog
      @close="showObjDataSetterF = false"
      v-if="showObjDataSetterF"
      :visible="showObjDataSetterF"
      title="设置标记数据"
      :noFooter="true">
      <div style="text-align: center;">
        元素颜色：
        <input type="color" v-model="objDataSetter.colorName">；
        所属地区：
        <select v-model="mapProvinceActive">
          <option v-for="(item, index) in mapProvinceList" :key="index" :label="item" :value="item"></option>
        </select>
      </div>
      <el-button @click="createPointData()" size="medium" type="primary">确定</el-button>
    </nut-dialog>
  </div>
</template>

<script>
import api from '../../../api/index'
import { loadModules } from 'esri-loader'
import flvjs from 'flv.js'
// import { clipboard } from 'electron'
// mapicons
import mapiconblue from '@/assets/mapicons/mapiconblue.png'
import mapicongreen from '@/assets/mapicons/mapicongreen.png'
import mapiconyellow from '@/assets/mapicons/mapiconyellow.png'
import mapiconred from '@/assets/mapicons/mapiconred.png'
import mapiconblack from '@/assets/mapicons/mapiconblack.png'
import atmosiconblue from '@/assets/mapicons/atmosiconblue.png'
import atmosicongreen from '@/assets/mapicons/atmosicongreen.png'
import atmosiconyellow from '@/assets/mapicons/atmosiconyellow.png'
import atmosiconred from '@/assets/mapicons/atmosiconred.png'
import atmosiconblack from '@/assets/mapicons/atmosiconblack.png'
import watericonblue from '@/assets/mapicons/watericonblue.png'
import watericongreen from '@/assets/mapicons/watericongreen.png'
import watericonyellow from '@/assets/mapicons/watericonyellow.png'
import watericonred from '@/assets/mapicons/watericonred.png'
import watericonblack from '@/assets/mapicons/watericonblack.png'
import uelectroiconblue from '@/assets/mapicons/uelectroiconblue.png'
import uelectroicongreen from '@/assets/mapicons/uelectroicongreen.png'
import uelectroiconyellow from '@/assets/mapicons/uelectroiconyellow.png'
import uelectroiconred from '@/assets/mapicons/uelectroiconred.png'
import uelectroiconblack from '@/assets/mapicons/uelectroiconblack.png'
import uwatericonblue from '@/assets/mapicons/uwatericonblue.png'
import uwatericongreen from '@/assets/mapicons/uwatericongreen.png'
import uwatericonyellow from '@/assets/mapicons/uwatericonyellow.png'
import uwatericonred from '@/assets/mapicons/uwatericonred.png'
import uwatericonblack from '@/assets/mapicons/uwatericonblack.png'
import ehsEQMAtmos from '../ehs-com/ehsEQMAtmos'
import ehsEQMWater from '../ehs-com/ehsEQMWater'
import ehsEQMUelectro from '../ehs-com/ehsEQMUelectro'
import ehsEQMUwater from '../ehs-com/ehsEQMUwater'
export default {
  props: ['activeTab', 'subType'],
  data () {
    return {
      subTypeMode: this.subType,
      homeTypeTab: this.activeTab || 'map',
      filterType: [0, 1, 2, 3, 4],
      gisAppliView: null,
      gisBackupViewParams: null,
      gisMap: null,
      gisMapView: null,
      gisScene: null,
      gisSceneView: null,
      gisWMTSLayer: null,
      gisWMTSLayerScene: null,
      // gisVectorTileLayer: null,
      // gisVectorTileLayerScene: null,
      tdtIBOLayer: null,
      tdtCIALayer: null,
      tdtCVALayer: null,
      tdtIBOLayerScene: null,
      tdtCIALayerScene: null,
      tdtCVALayerScene: null,
      gisSearch: null,
      gisSearchScene: null,
      gisSketchsLayer: null,
      gisStationsLayer: null,
      gisGraphicsLayer: null,
      gisSketch: null,
      gisTimeSlider: null,
      activeWidget: null,
      crtBaseMap: 'streets-relief-vector',
      baseMaps: ['osm'],
      // baseMaps: ['satellite', 'osm'],
      mapLayerType: 'WMTS',
      mapLayerTypeArr: ['none', 'WMTS'],
      viewDimensionType: '2d',
      // visible: true,
      markerIconList: {
        mapicon: {
          blue: mapiconblue,
          green: mapicongreen,
          yellow: mapiconyellow,
          red: mapiconred,
          black: mapiconblack
        },
        atmosicon: {
          blue: atmosiconblue,
          green: atmosicongreen,
          yellow: atmosiconyellow,
          red: atmosiconred,
          black: atmosiconblack
        },
        watericon: {
          blue: watericonblue,
          green: watericongreen,
          yellow: watericonyellow,
          red: watericonred,
          black: watericonblack
        },
        uelectroicon: {
          blue: uelectroiconblue,
          green: uelectroicongreen,
          yellow: uelectroiconyellow,
          red: uelectroiconred,
          black: uelectroiconblack
        },
        uwatericon: {
          blue: uwatericonblue,
          green: uwatericongreen,
          yellow: uwatericonyellow,
          red: uwatericonred,
          black: uwatericonblack
        }
      },
      gisWMTSSublayers: [],
      gisWidgetUnlockDatas: {
        name: '站点记录',
        time: '24h',
        point: '24',
        isUnlocked: false
      },
      // activeLayerDate: '',
      activeStopDate: '',
      mapProvinceActive: '北京市',
      mapProvinceList: [
        '北京市', '天津市', '河北省', '山西省', '内蒙古自治区',
        '辽宁省', '吉林省', '黑龙江省',
        '上海市', '江苏省', '浙江省', '安徽省', '福建省', '江西省', '山东省',
        '河南省', '湖北省', '湖南省', '广东省', '广西壮族自治区', '海南省',
        '四川省', '贵州省', '云南省', '西藏自治区', '重庆市',
        '陕西省', '甘肃省', '青海省', '宁夏回族自治区', '新疆维吾尔自治区'
      ],
      fullScreenBtn: null,
      switchMapBtn: null,
      switchOSMBtn: null,
      switchDBtn: null,
      stationListBtn: null,
      showTimeSliderBtn: null,
      createObjBtn: null,
      mapFullScreenFlag: false,
      showUnlockerFlag: false,
      showTimeSliderFlag: false,
      selectedData: {},
      showSelectObjTypeFlag: false,
      regularColors: { // rgb
        black: ['33', '33', '33'],
        blue: ['11', '95', 'db'],
        green: ['2a', 'a5', '15'],
        yellow: ['ef', 'b3', '36'],
        red: ['d8', '1e', '06'],
        strokeColor: ['99', '99', '99'],
        transparency: '99'
      },
      objDataSetter: {
        cPoint: [],
        colorName: '#1195db'
      },
      ringsList: [],
      createType: '',
      markerDataMntList: [],
      markerDatas: [{
        order: 0,
        mntType: 'map',
        mntDataSrc: '',
        mntVideo: {
          videoSrc: '',
          videoType: ''
        },
        markerData: {
          markerName: '默认站点',
          markerTypeValue: 2,
          markerType: 4,
          markerPosition: []
        },
        eqmData: {
        }
      }],
      markerDataArea: {},
      showMarkerDataSetter: false,
      showMarkerDataEditor: false,
      markerDataSetter: {
        order: '',
        mntType: 'map',
        mntDataSrc: '',
        mntVideo: {
          videoSrc: '',
          videoType: 'flv'
        },
        markerData: {
          markerName: '',
          markerTypeValue: 0,
          markerType: 0,
          markerPosition: []
        },
        eqmData: {
          eqmTime: '',
          atmosClass: '二级',
          waterClass: 'iii',
          maxRatioItem: { id: '', unit: '', value: 0, ratio: 0 }
        }
      },
      objAreaDataArea: {},
      showObjAreaDataSetter: false,
      objAreaDataSetter: {
        path: [],
        colorName: 'blue',
        colorHArr: ['11', '95', 'db']
      },
      buildingDataArea: {},
      showBuildingDataSetter: false,
      buildingDataSetter: {
        bounds: [],
        height: 50,
        colorName: 'blue',
        colorHArr: ['11', '95', 'db']
      },
      cylinderDataArea: {},
      showCircleDataSetter: false,
      cylinderDataSetter: {
        center: [],
        segment: 32,
        colorName: 'blue',
        colorHArr: ['11', '95', 'db'],
        height: 250,
        radius: 0
      },
      mapObjOptions: [],
      objAreaOptions: [{
        path: [],
        colorName: 'blue',
        colorHArr: []
      }],
      buildingOptions: [{
        bounds: [],
        height: 50,
        colorName: 'blue',
        colorHArr: []
      }],
      cylinderOptions: [{
        center: [],
        segment: 32,
        colorName: 'red',
        colorHArr: ['d8', '1e', '06'],
        height: 200,
        radius: 50
      }],
      showCreateObjAreaFlag: false,
      showCreateBuildingFlag: false,
      showCreateCylinderFlag: false,
      showObjDataSetterF: false,
      hideLeftDiv: true,
      hideRightDiv: false,
      eqmMntOrder: 0,
      eqmMntType: '',
      eqmClass: '',
      showDetailsAtmos: false,
      showDetailsWater: false,
      showDetailsUelectro: false,
      showDetailsUwater: false,
      showClick: false,
      showFilterForm: false,
      showVideoPlayer: false,
      filterblue: false,
      filtergreen: false,
      filteryellow: false,
      filterred: false,
      filterblack: false,
      markerSearch: '',
      tdtTk: 'daf534f80a571d37738cc8e681b1e2cd'
    }
  },
  computed: {
  },
  mounted () {
    // this.initGIBSLeaflet()
    this.mapinit()
    this.getDftMapProvince()
  },
  methods: {
    getDftMapProvince () {
      api.appUserMapProvinceEnquiry().then(res => {
        this.mapProvinceActive = res.data
        var initSearch = setInterval(() => {
          if ('searchTerm' in this.gisSearch) {
            clearInterval(initSearch)
            this.provinceChange()
          } else {
            console.log('gisSearch initing')
          }
        }, 500)
      })
    },
    markerPosLngZ (e) {
      var o = e.target
      o.value = o.value.replace(/[^0-9.]/g, '')
      if (o.value && !o.value.endsWith('.')) {
        o.value = o.value > 180 ? 180 : o.value
        o.value = o.value < 0 ? 0 : o.value
        o.value = Number(Number(o.value).toFixed(14))
      }
      this.markerDataSetter.markerData.markerPosLng = o.value
    },
    markerPosLatZ (e) {
      var o = e.target
      o.value = o.value.replace(/[^0-9.]/g, '')
      if (o.value && !o.value.endsWith('.')) {
        o.value = o.value > 85 ? 85 : o.value
        o.value = o.value < 0 ? 0 : o.value
        o.value = Number(Number(o.value).toFixed(14))
      }
      this.markerDataSetter.markerData.markerPosLat = o.value
    },
    mapinit () {
      loadModules([
        'esri/Map',
        'esri/views/MapView',
        'esri/views/SceneView',
        'esri/Basemap',
        'esri/layers/WMTSLayer',
        'esri/layers/VectorTileLayer',
        'esri/layers/GraphicsLayer',
        'esri/layers/WebTileLayer',
        'esri/widgets/Compass',
        'esri/widgets/Search',
        'esri/widgets/ScaleBar'
        // 'esri/toolbars/navigation'
        // 'esri/dijit/Scalebar'
      ], { css: true }).then(([
        ArcGISMap,
        MapView,
        SceneView,
        Basemap,
        WMTSLayer,
        VectorTileLayer,
        GraphicsLayer,
        WebTileLayer,
        Compass,
        Search,
        ScaleBar
        // Toolbars,
        // Scalebar
      ]) => {
        this.initView(Basemap, ArcGISMap, MapView, SceneView, WebTileLayer)
        // // 2D地图底图
        // this.gisMap = new ArcGISMap({
        //   basemap: this.crtBaseMap
        // })
        // basemap
        // const baseMap = new Basemap({
        //   portalItem: {
        //     id: 'bc19c34549de4000bcd91cef929420dc'
        //   }
        // })
        // // 2D地图底图
        // this.gisMap = new ArcGISMap({
        //   // basemap: this.crtBaseMap
        //   basemap: baseMap
        // })
        // // 3D地图底图
        // this.gisScene = new ArcGISMap({
        //   basemap: 'sitellite',
        //   ground: 'world-elevation'
        // })
        // 2D地图视图对象
        this.gisMapView = new MapView({
          // container: document.getElementById('mapView'),
          center: [116.391349, 39.907375],
          map: this.gisMap,
          zoom: 17
        })
        // 3D地图视图对象
        this.gisSceneView = new SceneView({
          // container: document.getElementById('mapView'),
          container: null,
          center: [116.391349, 39.907375],
          map: this.gisScene,
          zoom: 17
        })
        // 切换2d/3d
        this.gisAppliView = {
          mapView: null,
          sceneView: null,
          activeView: null,
          container: document.getElementById('mapView')
          // container: null
        }
        this.gisBackupViewParams = {
          zoom: 17,
          center: [116.391349, 39.907375]
          // container: this.gisAppliView.document
        }
        this.gisAppliView.mapView = this.gisMapView
        this.gisAppliView.sceneView = this.gisSceneView
        this.gisAppliView.activeView = this.gisAppliView.mapView
        this.gisAppliView.activeView.container = this.gisAppliView.container
        // this.gisBackupViewParams.container = null
        // this.gisBackupViewParams.map = this.gisScene
        // gisMapImageLayer
        // const gisMapImageLayer = new MapImageLayer({
        //   url: 'https://sampleserver6.arcgisonline.com/arcgis/rest/services/Census/MapServer
        // })
        // this.gisScene.add(gisMapImageLayer)
        // WMTS图层
        this.gisWMTSLayer = new WMTSLayer({
          url: 'https://wayback.maptiles.arcgis.com/arcgis/rest/services/world_imagery/wmts',
          copyright:
            '<a href="https://www.arcgis.com/index.html">Earthdata</a> by Esri',
          activeLayer: {
            id: 'SRTM_Color_Index'
          }
        })
        this.gisMap.add(this.gisWMTSLayer)
        this.gisWMTSLayerScene = new WMTSLayer({
          url: 'https://wayback.maptiles.arcgis.com/arcgis/rest/services/world_imagery/wmts',
          copyright:
            '<a href="https://www.arcgis.com/index.html">Earthdata</a> by Esri',
          activeLayer: {
            id: 'SRTM_Color_Index'
          }
        })
        this.gisScene.add(this.gisWMTSLayerScene)
        // this.gisScene.add(this.gisWMTSLayer)
        // let getSublayers = setInterval(() => {
        //   if (this.gisWMTSLayer.sublayers) {
        //     clearInterval(getSublayers)
        //     let gisWMTSSublayersPusher = []
        //     this.gisWMTSLayer.sublayers.items.forEach(item => {
        //       gisWMTSSublayersPusher.push({
        //         date: item.title.slice(-11, -1),
        //         item: item
        //       })
        //     })
        //     this.gisWMTSSublayers = gisWMTSSublayersPusher
        //     console.log('sublayers', this.gisWMTSSublayers)
        //     this.createTimeSlider(TimeSlider)
        //   } else {
        //     console.log('gisWMTSSublayers: null')
        //   }
        // }, 100)
        // 矢量图层 // url为eris online图层的样式地址
        // this.gisVectorTileLayer = new VectorTileLayer({
        //   title: '2d矢量图层',
        //   url: 'https://www.arcgis.com/sharing/rest/content/items/2a2e806e6e654ea78ecb705149ceae9f/resources/styles/root.json?f=pjson'
        // })
        // this.gisMap.add(this.gisVectorTileLayer)
        // console.log('gisVectorTileLayer')
        // this.gisVectorTileLayerScene = new VectorTileLayer({
        //   title: '3d矢量图层',
        //   url: 'https://www.arcgis.com/sharing/rest/content/items/2a2e806e6e654ea78ecb705149ceae9f/resources/styles/root.json?f=pjson'
        // })
        // this.gisScene.add(this.gisVectorTileLayerScene)
        // console.log('gisVectorTileLayerScene')
        // 天地图标注图层
        this.tdtIBOLayer = new WebTileLayer({ // 天地图-全球境界
          urlTemplate: 'https://{subDomain}.tianditu.gov.cn/ibo_w/wmts?SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=ibo&STYLE=default&TILEMATRIXSET=w&FORMAT=tiles&TILEMATRIX={level}&TILEROW={row}&TILECOL={col}&tk=' + this.tdtTk,
          subDomains: ['t0', 't1', 't2', 't3', 't4', 't5', 't6', 't7'],
          title: '天地图-全球境界'
        })
        this.tdtCIALayer = new WebTileLayer({ // 天地图-影像注记
          urlTemplate: 'https://{subDomain}.tianditu.gov.cn/cia_w/wmts?SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=cia&STYLE=default&TILEMATRIXSET=w&FORMAT=tiles&TILEMATRIX={level}&TILEROW={row}&TILECOL={col}&tk=' + this.tdtTk,
          subDomains: ['t0', 't1', 't2', 't3', 't4', 't5', 't6', 't7'],
          title: '天地图-影像注记'
        })
        this.tdtCVALayer = new WebTileLayer({ // 天地图-矢量注记
          urlTemplate: 'https://{subDomain}.tianditu.gov.cn/cva_w/wmts?SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=cva&STYLE=default&TILEMATRIXSET=w&FORMAT=tiles&TILEMATRIX={level}&TILEROW={row}&TILECOL={col}&tk=' + this.tdtTk,
          subDomains: ['t0', 't1', 't2', 't3', 't4', 't5', 't6', 't7'],
          title: '天地图-矢量注记'
        })
        this.tdtIBOLayerScene = new WebTileLayer({ // 3d天地图-全球境界
          urlTemplate: 'https://{subDomain}.tianditu.gov.cn/ibo_w/wmts?SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=ibo&STYLE=default&TILEMATRIXSET=w&FORMAT=tiles&TILEMATRIX={level}&TILEROW={row}&TILECOL={col}&tk=' + this.tdtTk,
          subDomains: ['t0', 't1', 't2', 't3', 't4', 't5', 't6', 't7'],
          title: '3d天地图-全球境界'
        })
        this.tdtCIALayerScene = new WebTileLayer({ // 3d天地图-影像注记
          urlTemplate: 'https://{subDomain}.tianditu.gov.cn/cia_w/wmts?SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=cia&STYLE=default&TILEMATRIXSET=w&FORMAT=tiles&TILEMATRIX={level}&TILEROW={row}&TILECOL={col}&tk=' + this.tdtTk,
          subDomains: ['t0', 't1', 't2', 't3', 't4', 't5', 't6', 't7'],
          title: '3d天地图-影像注记'
        })
        this.tdtCVALayerScene = new WebTileLayer({ // 3d天地图-矢量注记
          urlTemplate: 'https://{subDomain}.tianditu.gov.cn/cva_w/wmts?SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=cva&STYLE=default&TILEMATRIXSET=w&FORMAT=tiles&TILEMATRIX={level}&TILEROW={row}&TILECOL={col}&tk=' + this.tdtTk,
          subDomains: ['t0', 't1', 't2', 't3', 't4', 't5', 't6', 't7'],
          title: '3d天地图-矢量注记'
        })
        this.gisMap.addMany([this.tdtIBOLayer, this.tdtCIALayer, this.tdtCVALayer])
        this.gisScene.addMany([this.tdtIBOLayerScene, this.tdtCIALayerScene, this.tdtCVALayerScene])
        // 创建图层
        this.gisSketchsLayer = new GraphicsLayer({ title: '草图图层' })
        this.gisStationsLayer = new GraphicsLayer({ title: '站点图层' })
        this.gisGraphicsLayer = new GraphicsLayer({ title: '几何图层' })
        this.gisMap.addMany([this.gisGraphicsLayer, this.gisStationsLayer, this.gisSketchsLayer])
        // 3d图层
        this.gisSketchsLayerScene = new GraphicsLayer({ title: '3d草图图层' })
        this.gisStationsLayerScene = new GraphicsLayer({ title: '3d站点图层' })
        this.gisGraphicsLayerScene = new GraphicsLayer({ title: '3d几何图层' })
        this.gisGraphicsLayerSceneAux = new GraphicsLayer({ title: '3d辅助几何图层' })
        this.gisScene.addMany([this.gisGraphicsLayerSceneAux, this.gisGraphicsLayerScene, this.gisStationsLayerScene, this.gisSketchsLayerScene])
        // // 3dSceneLayer
        // this.gisSceneLayerScene = new SceneLayer({
        //   url: 'https://scene.arcgis.com/arcgis/rest/services/Hosted/Building_Hamburg/SceneServer/layers/0',
        //   popupEnabled: true,
        //   title: '3d场景图层'
        // })
        // this.gisScene.add(this.gisSceneLayerScene)
        // 2d自定义控件
        this.gisMapView.ui.add(this.setStationListBtn(), { position: 'top-left', index: 0 })
        this.gisMapView.ui.add(this.setFullScreenBtn(), { position: 'top-left', index: 3 })
        this.gisMapView.ui.add(this.setSwitchMapBtn(), { position: 'top-left', index: 4 })
        this.gisMapView.ui.add(this.setSwitchOSMBtn(), { position: 'top-left', index: 5 })
        this.gisMapView.ui.add(this.setSwitchDBtn(), { position: 'top-left', index: 6 })
        this.gisMapView.ui.add(this.setShowTimeSlider(), { position: 'bottom-left', index: 0 })
        // this.gisMapView.ui.add(this.setCreateObjBtn(), { position: 'top-right', index: 2 })
        this.gisMapView.ui.add('provinceListBar2D', { position: 'bottom-right', index: 1 })
        // 3d
        this.gisSceneView.ui.add(this.setStationListBtn(), { position: 'top-left', index: 0 })
        this.gisSceneView.ui.add(this.setFullScreenBtn(), { position: 'top-left', index: 3 })
        this.gisSceneView.ui.add(this.setSwitchMapBtn(), { position: 'top-left', index: 4 })
        this.gisSceneView.ui.add(this.setSwitchOSMBtn(), { position: 'top-left', index: 5 })
        this.gisSceneView.ui.add(this.setSwitchDBtn(), { position: 'top-left', index: 6 })
        this.gisSceneView.ui.add(this.setShowTimeSlider(), { position: 'bottom-left', index: 0 })
        this.gisSceneView.ui.add('provinceListBar3D', { position: 'bottom-right', index: 0 })
        // 站点记录时间轴
        this.createTimeSlider(new Date())
        // 搜索
        this.gisSearch = new Search({ view: this.gisMapView })
        this.gisSearch.locationEnabled = false
        this.gisSearch.on('search-start', (event) => {
          this.gisMapView.popup.open({
            actions: []
          })
        })
        this.gisMapView.ui.add(this.gisSearch, { position: 'top-left', index: 0 })
        this.gisSearchScene = new Search({ view: this.gisSceneView })
        this.gisSearchScene.locationEnabled = false
        this.gisSearchScene.on('search-start', (event) => {
          this.gisSceneView.popup.open({
            actions: []
          })
        })
        this.gisSceneView.ui.add(this.gisSearchScene, { position: 'top-left', index: 0 })
        // 定位
        // var gisLocate = new Locate({
        //   view: this.gisMapView,
        //   useHeadingEnabled: false
        // })
        // this.gisMapView.ui.add(gisLocate, 'bottom-right')
        // 指南针
        const gisCompass = new Compass({
          view: this.gisMapView
        })
        this.gisMapView.ui.add(gisCompass, 'top-left')
        // 比例尺
        var scaleBar = new ScaleBar({
          view: this.gisMapView,
          style: 'rule',
          unit: 'metric'
        })
        this.gisMapView.ui.add(scaleBar, 'bottom-right')
        // 图层列表
        // const gisLayerList = new LayerList({
        //   view: this.gisMapView
        // })
        // this.gisMapView.ui.add(gisLayerList, { position: 'top-right', index: 1 })
        // 绘图工具
        // this.gisSketch = new Sketch({
        //   layer: this.gisSketchsLayer,
        //   view: this.gisMapView,
        //   availableCreateTools: ['point', 'polygon', 'rectangle', 'circle'],
        //   creationMode: 'update' // graphic will be selected as soon as it is created
        // })
        // this.gisMapView.ui.add(this.gisSketch, 'top-right')
        // this.gisSketchCreateObjs(this.gisSketch, webMercatorUtils)
        // 测量
        this.gisMeasurement()
        // 区划图层
        // const gisFeatureLayer = new FeatureLayer({
        //   url: 'http://map.geoq.cn/ArcGIS/rest/services/ChinaOnlineCommunity/MapServer' // 没找
        // })
        // this.gisMap.add(gisFeatureLayer)
        // 添加覆盖物
        this.addGraphics()
        // 初始化弹窗
        this.initPopup()
        // 点击事件
        this.initClickEvt()
      })
    },
    initView (Basemap, ArcGISMap, MapView, SceneView, WebTileLayer) {
      this.gisAppliView = {
        mapView: null,
        sceneView: null,
        activeView: null,
        container: document.getElementById('mapView')
      }
      this.gisBackupViewParams = {
        map: null,
        zoom: 17,
        center: [120, 30],
        container: null
      }
      // // 2D地图底图
      // this.gisMap = new ArcGISMap({
      //   basemap: this.crtBaseMap
      // })
      // // 3D地图底图
      // this.gisScene = new ArcGISMap({
      //   basemap: this.crtBaseMap,
      //   ground: 'world-elevation'
      // })
      // basemap
      // const baseMap = new Basemap({
      //   portalItem: {
      //     id: 'bc19c34549de4000bcd91cef929420dc'
      //   }
      // })
      const baseMap2d = new WebTileLayer({ // 天地图影像
        urlTemplate: 'https://{subDomain}.tianditu.gov.cn/vec_w/wmts?SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=vec&STYLE=default&TILEMATRIXSET=w&FORMAT=tiles&TILECOL={col}&TILEROW={row}&TILEMATRIX={level}&tk=' + this.tdtTk,
        subDomains: ['t0', 't1', 't2', 't3', 't4', 't5', 't6', 't7'],
        copyright: '天地图底图'
      })
      const baseMap3d = new WebTileLayer({ // 天地图影像
        urlTemplate: 'https://{subDomain}.tianditu.gov.cn/vec_w/wmts?SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=vec&STYLE=default&TILEMATRIXSET=w&FORMAT=tiles&TILECOL={col}&TILEROW={row}&TILEMATRIX={level}&tk=' + this.tdtTk,
        subDomains: ['t0', 't1', 't2', 't3', 't4', 't5', 't6', 't7'],
        copyright: '天地图底图'
      })
      // 2D地图底图
      this.gisMap = new ArcGISMap({
        // basemap: this.crtBaseMap
        layers: [baseMap2d]
      })
      // 3D地图底图
      this.gisScene = new ArcGISMap({
        // basemap: baseMap,
        // basemap: 'satellite',
        layers: [baseMap3d],
        ground: 'world-elevation'
      })
      // init 2d mapView
      this.gisBackupViewParams.map = this.gisMap
      this.gisBackupViewParams.container = this.gisAppliView.container
      // this.gisAppliView.mapView = new MapView(this.gisBackupViewParams)
      this.gisAppliView.mapView = new MapView({
        map: this.gisMap,
        zoom: 17,
        center: [120, 30],
        container: this.gisAppliView.container
      })
      // init 3d sceneView
      this.gisBackupViewParams.map = this.gisScene
      this.gisBackupViewParams.container = null
      // this.gisAppliView.sceneView = new SceneView(this.gisBackupViewParams)
      this.gisAppliView.sceneView = new SceneView({
        map: this.gisScene,
        zoom: 17,
        center: [120.00000000, 30.00000000],
        container: null
      })
    },
    // createView (Mv, Sv, params, type) {
    //   var view
    //   if (type === '2d') {
    //     view = new Mv(params)
    //   } else {
    //     view = new Sv(params)
    //   }
    //   return view
    // },
    // 初始化弹窗
    initPopup () {
      this.gisMapView.popup.autoOpenEnabled = false
      this.gisSceneView.popup.autoOpenEnabled = false
      var popupOnEvt = (evt) => {
        console.log(evt, this.selectedData)
        switch (evt.action.id) {
          case 'showDetailsBtnS':
            this.showDetailsAtmos = false
            this.showDetailsWater = false
            this.showDetailsUelectro = false
            this.showDetailsUwater = false
            this.clickMarkerDetails(this.selectedData)
            break
          case 'editBtnS':
            this.showMarkerDataEditor = false
            this.showMarkerDataEditor = true
            this.markerDataSetter = this.selectedData
            break
          case 'deleteBtnS':
            var dltMConfirm = confirm('确认删除该站点?')
            if (dltMConfirm) {
              api.hbOnlineMonitoringDelete({
                id: this.selectedData.order
              }).then((resD) => {
                if (resD.code === 200) {
                  this.addGraphics()
                  this.gisMapView.popup.close()
                  this.gisSceneView.popup.close()
                  var dltMConfirmc = confirm('删除成功')
                  if (dltMConfirmc) {}
                }
              })
            } else {
              var dltMConfirmf = confirm('已取消删除')
              if (dltMConfirmf) {}
            }
            break
          case 'deleteBtnG':
            var dltConfirm = confirm('确认删除该元素?')
            if (dltConfirm) {
              api.hbCoverInterfaceDelete({
                id: this.selectedData.id
              }).then((resD) => {
                if (resD.code === 200) {
                  this.addGraphics()
                  this.gisMapView.popup.close()
                  this.gisSceneView.popup.close()
                  var dltConfirmc = confirm('删除成功')
                  if (dltConfirmc) {}
                }
              })
            } else {
              var dltConfirmf = confirm('已取消删除')
              if (dltConfirmf) {}
            }
            break
          case 'createPoint':
            this.showObjDataSetterF = true
            break
          case 'createMarker':
            this.showMarkerDataSetter = true
            break
        }
      }
      if (this.viewDimensionType === '2d') {
        this.gisMapView.popup.on('trigger-action', popupOnEvt)
      } else {
        this.gisSceneView.popup.on('trigger-action', popupOnEvt)
      }
      console.log('initPopupCompleted')
    },
    // 点击事件
    initClickEvt () {
      // this.gisMapView.popup.autoOpenEnabled = false
      var clickEvt = (evt) => {
        this.gisMapView.popup.close()
        this.gisSceneView.popup.close()
        var lngLat = {
          // 'longitude': webMercatorUtils.xyToLngLat(evt.mapPoint.x, evt.mapPoint.y)[0],
          // 'latitude': webMercatorUtils.xyToLngLat(evt.mapPoint.x, evt.mapPoint.y)[1]
          latitude: evt.mapPoint.latitude,
          longitude: evt.mapPoint.longitude
        }
        // this.objDataSetter.cPoint = lngLat
        this.markerDataSetter.markerData.markerPosition = [lngLat.longitude, lngLat.latitude]
        this.markerDataSetter.markerData.markerPosLng = lngLat.longitude
        this.markerDataSetter.markerData.markerPosLat = lngLat.latitude
        this.objDataSetter.cPoint = [lngLat.longitude, lngLat.latitude]
        console.log('lngLat', lngLat, evt)
        var openEvt = {
          title: '点击位置',
          content:
            `<p>坐标：${this.lnglatD2DMS(lngLat)} (${Math.round(lngLat.longitude * 1000000) / 1000000}, ${Math.round(lngLat.latitude * 1000000) / 1000000})`,
          location: evt.mapPoint,
          actions: [{
            title: '标记点',
            id: 'createPoint',
            image: require('@/assets/mapicons/mapiconblack.png')
          }, {
            title: '新增站点',
            id: 'createMarker',
            image: require('@/assets/mapicons/create_circle.png')
          }]
        }
        this.gisMapView.popup.open(openEvt)
        // this.gisSceneView.popup.open(openEvt)
        var hitTestEvt = (response) => {
          console.log(response)
          if (response.results.length) {
            var graphicData = response.results[0].graphic.attributes.data
            var layer = response.results[0].graphic.layer.title
            console.log(layer, graphicData)
            if (layer === '站点图层' || layer === '3d站点图层') {
              this.clickMarker(graphicData, evt, lngLat)
              // this.clickMarkerDetails(graphicData)
            } else if (layer === '几何图层' || layer === '3d几何图层') {
              this.clickGraphics(graphicData, response.results[0])
            }
          }
        }
        this.gisMapView.hitTest(evt).then(hitTestEvt)
        // this.gisSceneView.hitTest(evt).then(hitTestEvt)
      }
      this.gisMapView.on('click', clickEvt)
      // this.gisSceneView.on('click', clickEvt)
    },
    changeMapLayer (layerDate) {
      this.gisWMTSSublayers.forEach(element => {
        if (element.date === layerDate) {
          this.gisWMTSLayer.activeLayer = element.item
        }
      })
    },
    setStationListBtn () {
      var btn = document.createElement('img')
      btn.src = require('@/assets/mapicons/list.png')
      btn.title = '显示/隐藏列表'
      btn.style.width = '32px'
      btn.style.height = '32px'
      btn.style.cursor = 'pointer'
      btn.onclick = () => {
        this.hideRightDiv = !this.hideRightDiv
      }
      this.stationListBtn = btn
      return this.stationListBtn
    },
    setFullScreenBtn () {
      var btn = document.createElement('img')
      btn.src = require('@/assets/mapicons/fullScreenEnter.png')
      btn.title = '进入全屏'
      btn.style.width = '32px'
      btn.style.height = '32px'
      btn.style.borderTop = 'solid 1px #cccccc'
      btn.style.cursor = 'pointer'
      btn.onclick = () => {
        const mapContainer = document.getElementById('ehsGisMapWrap')
        const arcgisMapDiv = document.getElementById('arcgisMapDiv')
        if (this.mapFullScreenFlag) {
          document.webkitCancelFullScreen()
          btn.src = require('@/assets/mapicons/fullScreenEnter.png')
          btn.title = '进入全屏'
          arcgisMapDiv.style.height = 'calc(100vh - 80px)'
        } else {
          mapContainer.webkitRequestFullScreen()
          btn.src = require('@/assets/mapicons/fullScreenExit.png')
          btn.title = '退出全屏'
          arcgisMapDiv.style.height = 'calc(100vh - 40px)'
        }
        this.mapFullScreenFlag = !this.mapFullScreenFlag
      }
      this.fullScreenBtn = btn
      return this.fullScreenBtn
    },
    // 切换底图 // 备用
    // switchMapBtn () {
    //   const btn = document.createElement('img')
    //   btn.src = require('@/assets/mapicons/mapSwitch.png')
    //   btn.style.width = '32px'
    //   btn.style.height = '32px'
    //   btn.style.cursor = 'pointer'
    //   btn.style.marginBottom = '0'
    //   btn.onclick = () => {
    //     var index = this.baseMaps.indexOf(this.gisMap.basemap.id)
    //     this.gisMap.basemap = index < this.baseMaps.length - 1 ? this.baseMaps[++index] : this.baseMaps[0]
    //   }
    //   return btn
    // },
    // 切换显示图层
    setSwitchMapBtn () {
      var btn = document.createElement('img')
      btn.src = require('@/assets/mapicons/mapSwitch.png')
      btn.title = '切换地图'
      btn.style.width = '32px'
      btn.style.height = '32px'
      btn.style.cursor = 'pointer'
      btn.style.marginBottom = '0'
      btn.style.borderBottom = '1px solid #cccccc'
      btn.onclick = () => {
        // if (this.viewDimensionType === '2d') {
        // this.changePType()
        let index = this.mapLayerTypeArr.indexOf(this.mapLayerType)
        this.mapLayerType = index < this.mapLayerTypeArr.length - 1 ? this.mapLayerTypeArr[++index] : this.mapLayerTypeArr[0]
        if (this.mapLayerType === 'WMTS') {
          this.gisWMTSLayer.visible = true
          this.gisWMTSLayerScene.visible = true
          this.tdtIBOLayer.visible = this.tdtCVALayer.visible
          this.tdtCIALayer.visible = this.tdtCVALayer.visible
          this.tdtIBOLayerScene.visible = this.tdtCVALayerScene.visible
          this.tdtCIALayerScene.visible = this.tdtCVALayerScene.visible
          this.tdtCVALayer.visible = false
          this.tdtCVALayerScene.visible = false
        } else {
          this.gisWMTSLayer.visible = false
          this.gisWMTSLayerScene.visible = false
          this.tdtCVALayer.visible = this.tdtCIALayer.visible
          this.tdtCVALayerScene.visible = this.tdtCIALayerScene.visible
          this.tdtIBOLayer.visible = false
          this.tdtCIALayer.visible = false
          this.tdtIBOLayerScene.visible = false
          this.tdtCIALayerScene.visible = false
        }
        // }
      }
      this.switchMapBtn = btn
      return this.switchMapBtn
    },
    setSwitchOSMBtn () {
      var btn = document.createElement('img')
      btn.src = require('@/assets/mapicons/osm.png')
      btn.title = '显示/隐藏路网'
      btn.style.width = '32px'
      btn.style.height = '32px'
      btn.style.cursor = 'pointer'
      // btn.style.marginBottom = '0'
      btn.onclick = () => {
        if (this.mapLayerType === 'WMTS') {
          this.tdtIBOLayer.visible = !this.tdtIBOLayer.visible
          this.tdtCIALayer.visible = !this.tdtCIALayer.visible
          this.tdtIBOLayerScene.visible = !this.tdtIBOLayerScene.visible
          this.tdtCIALayerScene.visible = !this.tdtCIALayerScene.visible
        } else {
          this.tdtCVALayer.visible = !this.tdtCVALayer.visible
          this.tdtCVALayerScene.visible = !this.tdtCVALayerScene.visible
        }
      }
      this.switchOSMBtn = btn
      return this.switchOSMBtn
    },
    setSwitchDBtn () {
      var btn = document.createElement('img')
      btn.src = require('@/assets/mapicons/3D.png')
      btn.title = '切换为3D'
      btn.style.width = '32px'
      btn.style.height = '32px'
      btn.style.cursor = 'pointer'
      // btn.style.marginBottom = '0'
      btn.onclick = () => {
        this.gisBackupViewParams.center = this.gisAppliView.activeView.center
        this.gisBackupViewParams.scale = Math.round(this.gisAppliView.activeView.scale)
        this.gisAppliView.sceneView.scale = this.gisBackupViewParams.scale
        this.gisAppliView.mapView.scale = this.gisBackupViewParams.scale
        this.gisAppliView.activeView.container = null
        this.$nextTick().then(() => {
          if (this.viewDimensionType === '2d') {
            this.gisAppliView.sceneView.center = this.gisBackupViewParams.center
            this.gisAppliView.activeView = this.gisAppliView.sceneView
            this.gisAppliView.activeView.container = this.gisAppliView.container
            this.switchDBtn.title = '切换为2D'
            this.switchDBtn.src = require('@/assets/mapicons/2D.png')
            this.viewDimensionType = '3d'
          } else {
            this.gisAppliView.mapView.center = this.gisBackupViewParams.center
            this.gisAppliView.activeView = this.gisAppliView.mapView
            this.gisAppliView.activeView.container = this.gisAppliView.container
            this.switchDBtn.title = '切换为3D'
            this.switchDBtn.src = require('@/assets/mapicons/3D.png')
            this.viewDimensionType = '2d'
          }
          this.addGraphics()
        })
      }
      this.switchDBtn = btn
      return this.switchDBtn
    },
    setShowTimeSlider () {
      var btn = document.createElement('img')
      btn.src = require('@/assets/mapicons/timeSlider.png')
      btn.title = '站点记录'
      btn.style.width = '32px'
      btn.style.height = '32px'
      btn.style.cursor = 'pointer'
      btn.style.marginBottom = '0'
      btn.onclick = () => {
        var viewType
        if (this.viewDimensionType === '2d') {
          viewType = 'gisMapView'
        } else {
          viewType = 'gisSceneView'
        }
        if (this.showTimeSliderFlag) {
          this[viewType].ui.remove(this.gisTimeSlider)
          this.showTimeSliderFlag = false
          this.addGraphics('stations')
        } else {
          this[viewType].ui.add(this.gisTimeSlider, 'bottom-left')
          this.showTimeSliderFlag = true
          this.addGraphics('stations')
        }
      }
      this.showTimeSliderBtn = btn
      return this.showTimeSliderBtn
    },
    // 站点记录时间轴
    createTimeSlider (endDate) {
      loadModules([
        'esri/widgets/TimeSlider'
      ], { css: true }).then(([
        TimeSlider
      ]) => {
        var startDate = new Date()
        // var endDate = new Date()
        startDate.setDate(endDate.getDate() - 1)
        startDate.setMinutes(0)
        startDate.setSeconds(0)
        var stopsDates = [endDate]
        var intervalTime = 1
        for (var i = 0; i < 24; i++) {
          var stopDate = new Date()
          stopDate.setHours(endDate.getHours() - i * intervalTime)
          stopDate.setMinutes(0)
          stopDate.setSeconds(0)
          stopsDates.push(stopDate)
        }
        stopsDates.push(startDate)
        console.log('stopsDates', stopsDates)
        this.gisTimeSlider = new TimeSlider({
          // container: 'timeSliderView',
          // view: this.gisMapView,
          mode: 'cumulative-from-start',
          fullTimeExtent: {
            start: startDate,
            end: endDate
          },
          timeExtent: {
            start: null,
            end: endDate
          },
          playRate: 1000,
          stops: {
            // interval: {
            //   value: 1,
            //   unit: 'years'
            // },
            dates: stopsDates
          },
          tickConfigs: [{
            values: 0
          }],
          layout: 'wide',
          labelFormatFunction: (value, type, element, layout) => {
            switch (type) {
              case 'min':
              case 'max':
                break
              case 'extent':
                element.setAttribute(
                  'style',
                  'font-family: "Orbitron", sans-serif; font-size: 18px; color: red;'
                )
                var actStopDateS = this.dateUTC2GMT08(value[1])
                element.innerText = actStopDateS.slice(0, 16)
                if (this.activeStopDate !== actStopDateS) {
                  this.activeStopDate = actStopDateS
                  console.log('v', value[1], this.activeStopDate)
                  this.addGraphics('stations')
                }
                break
            }
          }
        })
        console.log('timeExtent', this.gisTimeSlider.timeExtent.end.toJSON())
        console.log('gisTimeSlider', this.gisTimeSlider)
      })
    },
    gisMeasurement () {
      var that = this
      loadModules([
        'esri/widgets/DistanceMeasurement2D',
        'esri/widgets/AreaMeasurement2D'
      ], { css: true }).then(([
        DistanceMeasurement2D,
        AreaMeasurement2D
      ]) => {
        that.gisMapView.ui.add('topbarMeasure', { position: 'top-right', index: 0 })
        document.getElementById('distanceButton').addEventListener('click', function () {
          setActiveWidget(null)
          if (!this.classList.contains('active')) {
            setActiveWidget('distance')
          } else {
            setActiveButton(null)
          }
        })
        document.getElementById('areaButton').addEventListener('click', function () {
          setActiveWidget(null)
          if (!this.classList.contains('active')) {
            setActiveWidget('area')
          } else {
            setActiveButton(null)
          }
        })
        function setActiveWidget (type) {
          switch (type) {
            case 'distance':
              that.activeWidget = new DistanceMeasurement2D({
                view: that.gisMapView
              })
              // skip the initial 'new measurement' button
              that.activeWidget.viewModel.start()
              that.gisMapView.ui.add(that.activeWidget, 'top-right')
              setActiveButton(document.getElementById('distanceButton'))
              break
            case 'area':
              that.activeWidget = new AreaMeasurement2D({
                view: that.gisMapView,
                label: '测距离'
              })
              // skip the initial 'new measurement' button
              that.activeWidget.viewModel.start()
              that.gisMapView.ui.add(that.activeWidget, 'top-right')
              setActiveButton(document.getElementById('areaButton'))
              break
            case null:
              if (that.activeWidget) {
                that.gisMapView.ui.remove(that.activeWidget)
                that.activeWidget.destroy()
                that.activeWidget = null
              }
              break
          }
        }
        function setActiveButton (selectedButton) {
          // focus the view to activate keyboard shortcuts for sketching
          that.gisMapView.focus()
          var elements = document.getElementsByClassName('active')
          for (var i = 0; i < elements.length; i++) {
            elements[i].classList.remove('active')
          }
          if (selectedButton) {
            selectedButton.classList.add('active')
          }
        }
      })
    },
    lnglatD2DMS (mtlnglat) {
      var mtLng = mtlnglat.longitude
      var mtLat = mtlnglat.latitude
      var d, m, s, t, lng, lat, lnglat
      d = parseInt(mtLng)
      m = parseInt((mtLng - d) * 60)
      s = Math.round(((mtLng - d) * 60 - m) * 60)
      if (d >= 0) {
        t = 'E'
      } else {
        t = 'W'
        d = -d
      }
      lng = d + '°' + m + '\'' + s + '"' + t
      d = parseInt(mtLat)
      m = parseInt((mtLat - d) * 60)
      s = Math.round(((mtLat - d) * 60 - m) * 60)
      if (d >= 0) {
        t = 'N'
      } else {
        t = 'S'
        d = -d
      }
      lat = d + '°' + m + '\'' + s + '"' + t
      lnglat = lng + ', ' + lat
      return lnglat
    },
    colorHArr2DArr (colorHArr) {
      var colorDArr = []
      JSON.parse(colorHArr).forEach((item) => {
        var dItem = Number(parseInt(item, 16).toString(10))
        colorDArr.push(dItem)
      })
      return colorDArr
    },
    colorHStr2HArr (colorHStr) {
      if (!colorHStr) {
        return ['00', '00', '00']
      } else {
        var colorHArr = [
          colorHStr.slice(1, 3),
          colorHStr.slice(3, 5),
          colorHStr.slice(5, 7)
        ]
        return colorHArr
      }
    },
    colorHStr2DArr (colorHStr) {
      var colorDArr = [
        Number(parseInt(colorHStr.slice(1, 3), 16).toString(10)),
        Number(parseInt(colorHStr.slice(3, 5), 16).toString(10)),
        Number(parseInt(colorHStr.slice(5, 7), 16).toString(10))
      ]
      return colorDArr
    },
    dateUTC2GMT08 (dateUTC) {
      var gmt08T = dateUTC.toLocaleTimeString('chinese', { hour12: false })
      var gmt08DArr = dateUTC.toLocaleDateString().split('/')
      var y = gmt08DArr[0]
      var m = gmt08DArr[1] < 10 ? '0' + gmt08DArr[1] : gmt08DArr[1]
      var d = gmt08DArr[2] < 10 ? '0' + gmt08DArr[2] : gmt08DArr[2]
      var gmt08 = y + '-' + m + '-' + d + ' ' + gmt08T
      return gmt08
    },
    getStationsList () {
      this.filterType = []
      if (!this.filterblue && !this.filtergreen && !this.filteryellow && !this.filterred && !this.filterblack) {
        console.log('getAll')
        this.filterType = [0, 1, 2, 3, 4]
      } else {
        if (this.filterblack) {
          console.log('getBlack')
          this.filterType.push(0)
        }
        if (this.filterblue) {
          console.log('getblue')
          this.filterType.push(1)
        }
        if (this.filtergreen) {
          console.log('getgreen')
          this.filterType.push(2)
        }
        if (this.filteryellow) {
          console.log('getyellow')
          this.filterType.push(3)
        }
        if (this.filterred) {
          console.log('getred')
          this.filterType.push(4)
        }
      }
      if (this.subTypeMode === 'monitors') {
        this.showVideoPlayer = false
        this.$nextTick(function () {
          this.showVideoPlayer = true
          this.startMntVideos()
        })
      }
      if (this.subTypeMode === 'dataMng') {
        this.hideLeftDiv = false
      } else {
        this.hideLeftDiv = true
      }
    },
    selectObjType (type) {
      switch (type) {
        case 'objArea':
          this.showSelectObjTypeFlag = false
          this.$nextTick(() => {
            this.showCreateObjAreaFlag = true
          })
          break
        case 'building':
          this.showSelectObjTypeFlag = false
          this.$nextTick(() => {
            this.showCreateBuildingFlag = true
          })
          break
      }
    },
    addGraphics (addType) {
      loadModules([
        'esri/Graphic',
        'esri/geometry/Circle'
      ], { css: true }).then(([
        Graphic,
        GeometryCircle
      ]) => {
        this.gisMapView.popup.close()
        this.gisSceneView.popup.close()
        this.showObjDataSetterF = false
        if (addType === 'graphics' || !addType) {
          api.hbCoverInterfaceEnquiry({
            province: this.mapProvinceActive
          }).then(resG => {
            if (resG.code === 200) {
              console.log('reaG', resG.data)
              this.gisGraphicsLayer.removeAll()
              this.gisGraphicsLayerScene.removeAll()
              this.gisGraphicsLayerSceneAux.removeAll()
              this.addObjAreas(Graphic, resG.data.objAreaOptions)
              this.addBuildings(Graphic, resG.data.buildingOptions)
              // this.addCylinders(Graphic, GeometryCircle, resG.data.cylinderOptions)
              this.addPoints(Graphic, resG.data.pointOptions)
              this.gisSketch.delete()
              console.log('delete completed')
            }
          })
        }
        if (addType === 'stations' || !addType) {
          this.addStations(Graphic)
        }
      })
    },
    addStations (Graphic) {
      console.log(this.homeTypeTab)
      console.log(this.filterType)
      this.getStationsList()
      var time = this.dateUTC2GMT08(new Date())
      var filterType = JSON.stringify(this.filterType).slice(1, -1)
      var enquiryPusher = {
        time: this.showTimeSliderFlag ? this.activeStopDate : time,
        markerType: filterType,
        province: this.mapProvinceActive
      }
      // var enquiryPusher = { markerType: '0,1,2,3,4' }
      if (this.homeTypeTab !== 'map') { enquiryPusher.mntType = this.homeTypeTab } else {}
      if (this.markerSearch !== '') { enquiryPusher.markerName = this.markerSearch }
      api.hbOnlineMonitoringEnquiry(enquiryPusher).then(resS => {
        if (resS.code === 200) {
          console.log('resS', resS.data)
          this.gisStationsLayer.removeAll()
          this.gisStationsLayerScene.removeAll()
          var tempArr = []
          resS.data.forEach(item => {
            var pos = JSON.parse(item.markerData.markerPosition)
            // addToList
            var enquiryPusher = {
              order: item.id,
              mntType: item.mntType,
              mntVideo: item.mntVideo,
              // mntDataSrc: item.mntDataSrc,
              mntDataMN: item.mntDataMN,
              mntDataPW: item.mntDataPW,
              markerData: {
                markerName: item.markerData.markerName,
                markerTypeValue: item.markerData.markerTypeValue,
                markerType: item.markerData.markerType,
                markerPosition: pos,
                markerPosLng: pos[0],
                markerPosLat: pos[1]
              },
              eqmData: item.eqmData
            }
            if ('atmosClass' in item.eqmData) { enquiryPusher.eqmData.atmosClass = item.eqmData.atmosClass }
            if ('waterClass' in item.eqmData) { enquiryPusher.eqmData.waterClass = item.eqmData.waterClass }
            tempArr.push(enquiryPusher)
            // addToMap
            var mntType = item.mntType
            var mkType = item.markerData.markerType
            var smntt, smkt, plclr
            if (mntType === 'map') { smntt = 'map' } else
            if (mntType === 'atmos') { smntt = 'atmos' } else
            if (mntType === 'water') { smntt = 'water' } else
            if (mntType === 'uelectro') { smntt = 'uelectro' } else
            if (mntType === 'uwater') { smntt = 'uwater' }
            if (mkType === 0) {
              smkt = 'black'
              plclr = [51, 51, 51]
            } else if (mkType === 1) {
              smkt = 'blue'
              plclr = [17, 149, 219]
            } else if (mkType === 2) {
              smkt = 'green'
              plclr = [42, 165, 21]
            } else if (mkType === 3) {
              smkt = 'yellow'
              plclr = [239, 179, 54]
            } else if (mkType === 4) {
              smkt = 'red'
              plclr = [216, 30, 6]
            }
            var smb = this.markerIconList[smntt + 'icon'][smkt]
            // console.log(smntt, smkt, smb)
            var point = new Graphic({
              geometry: {
                type: 'point',
                longitude: pos[0],
                latitude: pos[1],
                z: 90
              },
              symbol: {
                type: 'picture-marker',
                url: smb,
                width: '32px',
                height: '32px'
              },
              attributes: {
                data: enquiryPusher
              }
            })
            if (this.viewDimensionType === '2d') {
              this.gisStationsLayer.add(point)
            } else {
              this.gisStationsLayerScene.add(point)
              var polyline = new Graphic({
                geometry: {
                  type: 'polyline',
                  paths: [
                    [pos[0], pos[1], 0],
                    [pos[0], pos[1], 75]
                  ]
                },
                symbol: {
                  type: 'simple-line',
                  color: [...plclr, 0.5],
                  width: 2
                }
              })
              this.gisStationsLayerScene.add(polyline)
            }
          })
          // this.gisStationsLayer.on('rightclick', (ev) => {
          //   console.log(ev)
          // })
          this.markerDatas = tempArr
          this.markerDataMntList = tempArr
          console.log('markerDatas', this.markerDatas)
          if (this.subTypeMode === 'monitors') {
            this.startMntVideos()
          }
        }
      })
    },
    addObjAreas (Graphic, data) {
      data.forEach(item => {
        var polygon = new Graphic({
          geometry: {
            type: 'polygon',
            rings: JSON.parse(item.path)
          },
          symbol: {
            type: 'simple-fill', // autocasts as new SimpleFillSymbol()
            color: [...this.colorHArr2DArr(item.colorHArr), 0.3],
            outline: {
              color: [...this.colorHArr2DArr(item.colorHArr), 1],
              width: 1
            }
          },
          attributes: {
            data: item
          }
        })
        if (this.viewDimensionType === '2d') {
          this.gisGraphicsLayer.graphics.add(polygon)
        } else {
          this.gisGraphicsLayerScene.graphics.add(polygon)
        }
        console.log('addObjAreas completed', data)
      })
    },
    addBuildings (Graphic, data) {
      data.forEach(item => {
        var dataRings = JSON.parse(item.bounds)
        var rings = []
        if (this.viewDimensionType === '2d') {
          rings = dataRings
        } else {
          var tempArr = []
          for (var i = 0; i < dataRings.length; i++) {
            // 顶面
            var ringItem = dataRings[i]
            ringItem.push(item.height)
            tempArr.push(ringItem)
            // 侧面
            var bErr = 0.000000001
            var iErr = i + 1
            if (i >= dataRings.length - 1) {
              iErr = 0
            }
            var iair0t = [dataRings[i][0], dataRings[i][1], item.height]
            var iair0b = [dataRings[i][0] + bErr, dataRings[i][1] + bErr, 0]
            var iair1t = [dataRings[iErr][0], dataRings[iErr][1], item.height]
            var iair1b = [dataRings[iErr][0] + bErr, dataRings[iErr][1] + bErr, 0]
            var itemAuxItemRings = [iair0t, iair1t, iair1b, iair0b]
            // console.log('itemAuxItemRings', iErr, itemAuxItemRings)
            var itemAuxItem = new Graphic({
              geometry: {
                type: 'polygon',
                rings: itemAuxItemRings
              },
              symbol: {
                type: 'simple-fill', // autocasts as new SimpleFillSymbol()
                color: [...this.colorHArr2DArr(item.colorHArr), 0.5],
                outline: {
                  color: [...this.colorHArr2DArr(item.colorHArr), 1],
                  width: 1
                }
              }
            })
            this.gisGraphicsLayerSceneAux.graphics.add(itemAuxItem)
          }
          rings = tempArr
        }
        var polygon = new Graphic({
          geometry: {
            type: 'polygon',
            rings: rings
          },
          symbol: {
            type: 'simple-fill', // autocasts as new SimpleFillSymbol()
            color: [...this.colorHArr2DArr(item.colorHArr), 0.7],
            outline: {
              color: [...this.colorHArr2DArr(item.colorHArr), 1],
              width: 1
            }
          },
          attributes: {
            data: item
          },
          popupTemplate: {
            title: 'title'
          }
        })
        if (this.viewDimensionType === '2d') {
          this.gisGraphicsLayer.graphics.add(polygon)
        } else {
          this.gisGraphicsLayerScene.graphics.add(polygon)
        }
        console.log('addBuildings completed', data, this.colorHArr2DArr(item.colorHArr))
      })
    },
    addPoints (Graphic, data) {
      data.forEach(item => {
        var point = new Graphic({
          geometry: {
            type: 'point',
            longitude: JSON.parse(item.center)[0],
            latitude: JSON.parse(item.center)[1]
          },
          symbol: {
            type: 'simple-marker', // autocasts as new SimpleFillSymbol()
            color: [...JSON.parse(item.colorHArr), 0.8],
            size: 6,
            outline: {
              color: [255, 255, 255, 0.8],
              width: 1
            }
          },
          attributes: {
            data: item
          },
          popupTemplate: {
            title: 'title'
          }
        })
        if (this.viewDimensionType === '2d') {
          this.gisGraphicsLayer.add(point)
        } else {
          this.gisGraphicsLayerScene.graphics.add(point)
        }
        console.log('addPoint', point)
      })
    },
    // addCylinders (Graphic, GeometryCircle, data) {
    //   data.forEach(item => {
    //     var circleGeometry = new GeometryCircle({
    //       center: JSON.parse(item.center),
    //       geodesic: true,
    //       numberOfPoints: item.segment,
    //       radius: item.radius / 8,
    //       radiusUnit: 'meters'
    //     })
    //     var circle = new Graphic({
    //       geometry: circleGeometry,
    //       symbol: {
    //         type: 'simple-fill',
    //         color: [...this.colorHArr2DArr(item.colorHArr), 0.3],
    //         outline: {
    //           color: [...this.colorHArr2DArr(item.colorHArr), 1],
    //           width: 1
    //         }
    //       },
    //       attributes: {
    //         data: item
    //       }
    //     })
    //     this.gisGraphicsLayer.graphics.add(circle)
    //   })
    // },
    gisSketchCreateObjs (gisSketch, webMercatorUtils) {
      var that = this
      gisSketch.on('create', function (event) {
        console.log(event.state, event.tool, event.toolEventInfo)
      })
      gisSketch.on('update', function (event) {
        console.log(event, event.state, event.tool, event.toolEventInfo)
        var isIf = false
        if (event.state === 'start') {
          isIf = true
        } else if (event.state === 'active' && 'toolEventInfo' in event) {
          if (event.toolEventInfo.type.indexOf('stop') >= 0 || event.toolEventInfo.type.indexOf('remove') >= 0) {
            isIf = true
          }
        }
        // if (event.state === 'start' || (event.state === 'active' && (event.toolEventInfo.type.indexOf('stop') >= 0 || event.toolEventInfo.type.indexOf('remove') >= 0))) {
        if (isIf) {
          that.ringsList = []
          var isPoint = 0
          var isGraphic = 0
          event.graphics.forEach(item => {
            var type = item.geometry.type
            if (type === 'point') {
              isPoint = 1
              that.ringsList.push([item.geometry.longitude, item.geometry.latitude])
            } else if (type === 'polygon') {
              isGraphic = 1
              var mtRings = item.geometry.rings[0]
              for (var i = 1; i < mtRings.length; i++) {
                var pointLngLat = webMercatorUtils.xyToLngLat(mtRings[i][0], mtRings[i][1])
                that.ringsList.push(pointLngLat)
              }
            }
          })
          if (isPoint && isGraphic) {
            console.log('请勿同时选中点位和图形')
            that.createType = 'both'
          } else if (isPoint) {
            if (that.ringsList.length === 1) {
              console.log('PointOnly')
              that.createType = 'point'
              that.markerDataSetter.markerData.markerPosition = that.ringsList[0]
            } else {
              console.log('请勿同时选中多个点位')
              that.createType = 'multiPoints'
            }
          } else if (isGraphic) {
            console.log('GraphicsOnly')
            that.createType = 'graphics'
          }
          console.log(that.createType, 'ringsList', JSON.stringify(that.ringsList))
          that.createObjBtn.src = require('@/assets/mapicons/create_borderless.png')
          that.createObjBtn.title = '新增元素'
        } else if (event.state === 'complete') {
          that.createObjBtn.src = require('@/assets/mapicons/create_borderless_disabled.png')
          that.createObjBtn.title = '新增元素（禁用）'
          that.createType = 'none'
        }
      })
    },
    clickMarker (data) {
      var dataPos = {
        longitude: data.markerData.markerPosition[0],
        latitude: data.markerData.markerPosition[1],
        z: 90
      }
      this.selectedData = data
      var openEvt = {
        title: data.markerData.markerName,
        // content: '<p>坐标：' + JSON.stringify(lngLat), // content displayed in the popup
        content:
          `<p>坐标：${this.lnglatD2DMS(dataPos)} (${Math.round(dataPos.longitude * 1000000) / 1000000}, ${Math.round(dataPos.latitude * 1000000) / 1000000})`,
        //   `<p>坐标：${this.lnglatD2DMS(dataPos)} (${Math.round(dataPos.longitude * 1000000) / 1000000}, ${Math.round(dataPos.latitude * 1000000) / 1000000})`,
        // location: evt.mapPoint // Set the location of the popup to the clicked location
        location: dataPos,
        actions: [{
          title: '详情',
          id: 'showDetailsBtnS',
          image: require('@/assets/mapicons/details.png')
        }, {
          title: '编辑',
          id: 'editBtnS',
          image: require('@/assets/mapicons/edit.png')
        }, {
          title: '删除',
          id: 'deleteBtnS',
          image: require('@/assets/mapicons/delete.png')
        }]
      }
      if (this.viewDimensionType === '2d') {
        this.gisMapView.popup.open(openEvt)
      } else {
        this.gisSceneView.popup.open(openEvt)
      }
      console.log(this.gisSceneView)
    },
    clickGraphics (data, clkData) {
      this.selectedData = data
      var titleName = ''
      var cPoint = null
      switch (data.mapObjType) {
        case 'objArea':
          titleName = '区域'
          cPoint = clkData.graphic.geometry.centroid
          break
        case 'building':
          titleName = '建筑物'
          cPoint = clkData.graphic.geometry.centroid
          break
        // case 'cylinder':
        //   titleName = '建筑物'
        //   cPoint = clkData.graphic.geometry.centroid
        //   break
        case 'point':
          titleName = '点'
          cPoint = clkData.graphic.geometry
          break
      }
      var cPos = {
        longitude: cPoint.longitude,
        latitude: cPoint.latitude,
        z: data.height
      }
      this.gisMapView.popup.open({
        title: titleName,
        // content: '<p>坐标：' + JSON.stringify(lngLat), // content displayed in the popup
        content:
          `<p>中点坐标：${this.lnglatD2DMS(cPos)} (${Math.round(cPos.longitude * 1000000) / 1000000}, ${Math.round(cPos.latitude * 1000000) / 1000000})`,
        // location: evt.mapPoint // Set the location of the popup to the clicked location
        location: cPos,
        actions: [{
        //   title: '详情',
        //   id: 'showDetailsBtn',
        //   image: require('@/assets/mapicons/details.png')
        // }, {
        //   title: '编辑',
        //   id: 'editBtn',
        //   image: require('@/assets/mapicons/edit.png')
        // }, {
          title: '删除',
          id: 'deleteBtnG',
          image: require('@/assets/mapicons/delete.png')
        }]
      })
    },
    clickMarkerDetails (data) {
      this.eqmMntOrder = data.order
      this.eqmMntType = data.mntType
      if (data.mntType === 'water') {
        this.eqmClass = data.eqmData.waterClass
      }
      this.showDetailsType()
    },
    showDetailsType () {
      if (this.eqmMntType === 'atmos') {
        this.showDetailsAtmos = true
      } else if (this.eqmMntType === 'water') {
        this.showDetailsWater = true
      } else if (this.eqmMntType === 'uelectro') {
        this.showDetailsUelectro = true
      } else if (this.eqmMntType === 'uwater') {
        this.showDetailsUwater = true
      }
    },
    createMarkerData () {
      var doIf =
        this.markerDataSetter.markerData.markerName &&
        this.markerDataSetter.markerData.markerPosLng &&
        this.markerDataSetter.markerData.markerPosLat &&
        this.markerDataSetter.mntType &&
        this.markerDataSetter.mntDataMN &&
        this.markerDataSetter.mntDataPW
      if (doIf) {
        this.markerDataSetter.markerData.markerPosition = [this.markerDataSetter.markerData.markerPosLng, this.markerDataSetter.markerData.markerPosLat]
        this.showMarkerDataSetter = false
        var mds = this.markerDataSetter
        // mds.order = Number(this.markerDatas[this.markerDatas.length - 1].order) + 1
        this.markerDatas.push(mds)
        console.log('markerDataSetter', mds)
        console.log('markerDatas', this.markerDatas)
        // this.arrToStr('1D', mds.markerData.markerPosition)
        // var markerPosition = JSON.stringify([this.objDataSetter.cPoint.longitude, this.objDataSetter.cPoint.latitude])
        var markerPosition = JSON.stringify(mds.markerData.markerPosition)
        var addPusher = {
          mntType: mds.mntType,
          // mntDataSrc: mds.mntDataSrc,
          mntDataMN: mds.mntDataMN,
          mntDataPW: mds.mntDataPW,
          markerName: mds.markerData.markerName,
          markerPosition: markerPosition,
          videoSrc: mds.mntVideo.videoSrc,
          videoType: mds.mntVideo.videoType,
          province: this.mapProvinceActive
          // markerType: 0, // 临时
          // markerTypeValue: 0 // 临时
        }
        if (mds.mntType === 'atmos') { addPusher.atmosClass = mds.eqmData.atmosClass }
        if (mds.mntType === 'water') { addPusher.waterClass = mds.eqmData.waterClass }
        api.hbOnlineMonitoringAdd(addPusher).then(res => {
          console.log(res)
          console.log(mds.markerData.markerPosition)
          this.gisSketchsLayer.removeAll()
          this.addGraphics('stations')
          this.showMarkerDataSetter = false
          // this.$confirm('IP：47.114.110.8；端口：6668。（使用过程中出现问题，可点击左下角联系我们）', '新增成功', {
          //   confirmButtonText: '复制',
          //   cancelButtonText: '确定',
          //   type: 'warning'
          // }).then(() => {
          //   var text = 'IP：47.114.110.8，端口：6668'
          //   // clipboard.writeText(text)
          //   window.clipBoardData.setData('Text', text)
          //   this.$message.success('已复制到剪切板！')
          // }).catch(() => {})
          var afterMonitorAddConfirm = confirm('新增成功。IP：47.114.110.8；端口：6668。（使用过程中出现问题可联系我们）')
          if (afterMonitorAddConfirm) {}
        })
      } else {
        // this.$message.error('请填写必填项！')
        var beforeMonitorAddConfirm = confirm('请填写必填项！')
        if (beforeMonitorAddConfirm) {}
      }
    },
    editMarkerData () {
      var doIf =
        this.markerDataSetter.markerData.markerName &&
        this.markerDataSetter.markerData.markerPosLng &&
        this.markerDataSetter.markerData.markerPosLat &&
        this.markerDataSetter.mntType &&
        this.markerDataSetter.mntDataMN &&
        this.markerDataSetter.mntDataPW
      if (doIf) {
        this.markerDataSetter.markerData.markerPosition = [this.markerDataSetter.markerData.markerPosLng, this.markerDataSetter.markerData.markerPosLat]
        this.showMarkerDataEditor = false
        var mds = this.markerDataSetter
        // mds.order = Number(this.markerDatas[this.markerDatas.length - 1].order) + 1
        this.markerDatas.push(mds)
        console.log('markerDataSetter', mds)
        console.log('markerDatas', this.markerDatas)
        var markerPosition = JSON.stringify(mds.markerData.markerPosition)
        var editPusher = {
          id: mds.order,
          // mntDataSrc: mds.mntDataSrc,
          mntDataMN: mds.mntDataMN,
          mntDataPW: mds.mntDataPW,
          markerName: mds.markerData.markerName,
          markerPosition: markerPosition,
          videoSrc: mds.mntVideo.videoSrc,
          videoType: mds.mntVideo.videoType,
          province: this.mapProvinceActive
          // markerType: 0, // 临时
          // markerTypeValue: 0 // 临时
        }
        if (mds.mntType === 'atmos') { editPusher.atmosClass = mds.eqmData.atmosClass }
        if (mds.mntType === 'water') { editPusher.waterClass = mds.eqmData.waterClass }
        api.hbOnlineMonitoringUpdate(editPusher).then(res => {
          console.log(res)
          console.log(mds.markerData.markerPosition)
          this.addGraphics('stations')
          this.gisMapView.popup.close()
          this.gisSceneView.popup.close()
          this.showMarkerDataEditor = false
        })
      } else {
        // this.$message.error('请填写必填项！')
        var beforeMonitorAddConfirm = confirm('请填写必填项！')
        if (beforeMonitorAddConfirm) {}
      }
    },
    // setCreateObjBtn () {
    //   var btn = document.createElement('img')
    //   btn.src = require('@/assets/mapicons/create_borderless_disabled.png')
    //   btn.title = '新增元素（禁用）'
    //   btn.style.width = '32px'
    //   btn.style.height = '32px'
    //   btn.style.cursor = 'pointer'
    //   btn.style.borderRadius = '50%'
    //   btn.onclick = () => {
    //     console.log('createType:', this.createType)
    //     if (this.createType === 'both') {
    //       this.$message.error('请勿同时选中点位与图形')
    //     } else if (this.createType === 'multiPoints') {
    //       this.$message.error('请勿同时选中多个点位')
    //     } else if (this.createType === 'point') {
    //       this.markerDataSetter.markerData.markerPosition = this.ringsList[0]
    //       this.showMarkerDataSetter = true
    //     } else if (this.createType === 'graphics') {
    //       this.showSelectObjTypeFlag = true
    //       // this.$alert(
    //       //   '<div style="text-align: center;"><el-button @click="showSelectObjTypeFlag = false, showCreateObjAreaFlag = true" size="medium">新增区域</el-button><el-button @click="showSelectObjTypeFlag = false, showCreateBuildingFlag = true" size="medium">新增建筑物</el-button></div>',
    //       //   'HTML 片段', {}
    //       // )
    //     }
    //   }
    //   this.createObjBtn = btn
    //   return this.createObjBtn
    // },
    // setShowDetailsBtn () {
    //   var btn = document.createElement('img')
    //   btn.src = require('@/assets/mapicons/details_disabled.png')
    //   btn.title = '查看详情（禁用）'
    //   btn.style.width = '32px'
    //   btn.style.height = '32px'
    //   btn.style.cursor = 'pointer'
    //   btn.onclick = () => {
    //     this.clickMarkerDetails(data)
    //   }
    //   this.createObjBtn = btn
    //   return this.createObjBtn
    // },
    createPointData () {
      var ds = {
        mapObjType: 'point',
        colorHArr: JSON.stringify(this.colorHStr2HArr(this.objDataSetter.colorName)),
        center: JSON.stringify([this.objDataSetter.cPoint.longitude, this.objDataSetter.cPoint.latitude]),
        province: this.mapProvinceActive
      }
      api.hbCoverInterfaceAdd(ds).then(res => {
        console.log(res)
        this.addGraphics()
      })
    },
    createObjAreaData () {
      this.objAreaDataSetter.path = this.ringsList
      this.showObjAreaDataSetter = false
      var bads = this.objAreaDataSetter
      bads.colorHArr = this.colorHStr2HArr(bads.colorName)
      this.objAreaOptions = []
      this.objAreaOptions.push(bads)
      console.log('objAreaDataSetter', bads)
      console.log('objAreaOptions', this.objAreaOptions)
      // this.arrToStr('1D', bads.colorHArr)
      // var colorHArr = this.strFromArr1D
      // this.arrToStr('2D', bads.path)
      // var path = this.strFromArr2D
      var colorHArr = JSON.stringify(bads.colorHArr)
      var path = JSON.stringify(bads.path)
      api.hbCoverInterfaceAdd({
        mapObjType: 'objArea',
        path: path,
        colorHArr: colorHArr,
        province: this.mapProvinceActive
      }).then(res => {
        console.log(res)
        this.addGraphics()
        this.showCreateObjAreaFlag = false
      })
    },
    createBuildingData () {
      this.buildingDataSetter.bounds = this.ringsList
      this.showBuildingDataSetter = false
      var bds = this.buildingDataSetter
      bds.colorHArr = this.colorHStr2HArr(bds.colorName)
      // bds.colorHArr = this.regularColors[bds.colorName]
      this.buildingOptions = []
      this.buildingOptions.push(bds)
      console.log('buildingDataSetter', bds)
      console.log('buildingOptions', this.buildingOptions)
      // this.arrToStr('1D', bds.colorHArr)
      // var colorHArr = this.strFromArr1D
      // this.arrToStr('2D', bds.bounds)
      // var bounds = this.strFromArr2D
      var colorHArr = JSON.stringify(bds.colorHArr)
      var bounds = JSON.stringify(bds.bounds)
      api.hbCoverInterfaceAdd({
        mapObjType: 'building',
        bounds: bounds,
        height: bds.height,
        colorHArr: colorHArr,
        province: this.mapProvinceActive
      }).then(res => {
        console.log(res)
        this.addGraphics()
        this.showCreateBuildingFlag = false
      })
    },
    // createCircleData () {
    //   this.showCircleDataSetter = false
    //   var cds = this.cylinderDataSetter
    //   cds.colorHArr = this.colorHStr2HArr(cds.colorName)
    //   // cds.colorHArr = this.regularColors[cds.colorName]
    //   cds.radius = cds.radius * 8
    //   this.cylinderOptions = []
    //   this.cylinderOptions.push(cds)
    //   console.log('cylinderDataSetter', cds)
    //   console.log('cylinderOptions', this.cylinderOptions)
    //   var colorHArr = JSON.stringify(cds.colorHArr)
    //   var center = JSON.stringify(cds.center)
    //   api.hbCoverInterfaceAdd({
    //     mapObjType: 'cylinder',
    //     center: center,
    //     radius: cds.radius,
    //     segment: cds.segment,
    //     height: cds.height,
    //     colorHArr: colorHArr,
    //     province: this.mapProvinceActive
    //   }).then(res => {
    //     console.log(res)
    //     this.addGraphics()
    //   })
    // },
    provinceChange () {
      this.gisSearch.searchTerm = this.mapProvinceActive
      this.gisSearchScene.searchTerm = this.mapProvinceActive
      if (this.viewDimensionType === '2d') {
        this.gisSearch.search()
      } else if (this.viewDimensionType === '3d') {
        this.gisSearchScene.search()
      }
      api.appUserMapProvinceUpdate({
        province: this.mapProvinceActive
      }).then(resPr => {
        console.log(resPr)
        this.addGraphics()
      })
    },
    modeChange () {
      if (this.subTypeMode === 'areaIntros' || this.subTypeMode === 'dataMng') {
        this.subTypeMode = 'monitors'
        this.showVideoPlayer = true
        this.startMntVideos()
      } else {
        this.subTypeMode = 'areaIntros'
        this.showVideoPlayer = false
      }
    },
    startMntVideos () {
      var mntAddressList = []
      this.markerDatas.forEach(marker => {
        mntAddressList.push({
          order: marker.order,
          videoSrc: marker.mntVideo.videoSrc
        })
      })
      console.log('mntAddressList', mntAddressList)
      setTimeout(() => {
        console.log('mntAddressList', mntAddressList)
        mntAddressList.forEach(item => {
          if (flvjs.isSupported() && item.videoSrc) {
            console.log('mntVideo' + item.order)
            var player = null
            var videoElement = document.getElementById('mntVideo' + item.order)
            player = flvjs.createPlayer({
              type: 'flv', // 媒体类型 flv 或 mp4
              isLive: true, // 是否为直播流
              hasAudio: true, // 是否开启声音
              url: item.videoSrc // 视频流地址
            })
            player.attachMediaElement(videoElement)
            player.load()
            // player.play()
          } else {
            console.log('flvjs不支持')
          }
        })
      }, 1000)
    }
  },
  components: {
    ehsEQMAtmos,
    ehsEQMWater,
    ehsEQMUelectro,
    ehsEQMUwater
  }
}
</script>

<style lang="scss">
.ehsgismapwrap{
  font-family: 'Times New Roman', 'SimHei', Georgia, Times, serif;
  z-index: 0;
  // height: 100vh;
  overflow: hidden;
  .el-input__inner{
    height: 30px!important;
  }
  .ehstab{
    background-color: #003f7f;
    height: 40px!important;
    // padding: 2px 0px!important;
    width: 100%;
    .el-tabs__item{
      padding: 0;
      font-size: 20px;
      font-weight: bold;
      transition: 0.2s all;
      color: #007fff;
      line-height: 40px;
    }
    .is-active{
      color: #e0f0ff;
      transition: 0s all;
      background-color: #007fff;
    }
    .el-tabs__active-bar{
      transition: 0s all;
      background-color: #e0f0ff;
    }
  }
  .gismapdivcenter{
    // margin-left: 10px;
    // margin-right: 10px;
    display: flex;
    width: 100%;
    height: 100%;
    .rightdiv {
      float: left;
      width: 300px;
      margin-left: -300px;
      height: 100%;
      overflow: hidden;
      transition: 0.1s all;
      flex: none;
    }
    .rightside {
      margin-left: 0;
      background-color: #fff;
      float: left;
      width: 300px;
      height: 100%;
      overflow: hidden;
      transition: 0.1s all;
      flex: none;
    }
    .menu{
      margin-top: 0;
      .listheader{
        // padding: 0 0 2px 0;
        .el-button--primary{
          border-color: #003f7f!important;
        }
        .listTitle{
          display: flex;
          font-size: 14px;
          .listHideBtn{
            margin: 0!important;
            height: 30px;
            width: 100%!important;
            padding: 8px 5px!important;
            background: no-repeat;
            background-color: #003f7f;
            background-image: url('../../assets/mapicons/左箭头白.png');
            background-position: 50% 50%;
            background-size: 80%;
            border-radius: 0;
            flex: 1;
          }
          .markListTitle{
            text-align: center;
            height: 28px;
            line-height: 28px;
            font-size: 18px;
            border-top: 1px solid #003f7f;
            border-bottom: 1px solid #003f7f;
            // background-color: #003f7f;
            // color: #e0f0ff;
            color: #003f7f;
            font-weight: bold;
            flex: 10;
          }
          .modeChangeBtn{
            margin: 0!important;
            height: 30px;
            width: 100%!important;
            padding: 8px 5px!important;
            background: no-repeat;
            background-color: #003f7f;
            background-position: 50% 50%;
            background-size: 80%;
            border-radius: 0;
            flex: 1;
          }
          .listicon{
            background-image: url('../../assets/mapicons/list_white.png');
          }
          .mnticon{
            background-image: url('../../assets/mapicons/监控白.png');
          }
        }
        .markSearch{
          margin: 2px 0 2px;
          height: 30px;
          text-align: center;
          line-height: 30px;
          display: flex;
          // font-size: 18px;
          .markFilterbtn{
            margin: 0!important;
            height: 30px;
            width: 100%!important;
            padding: 8px 5px!important;
            background: no-repeat;
            background-color: #003f7f;
            background-image: url('../../assets/mapicons/筛选白.png');
            background-position: 50% 50%;
            background-size: 80%;
            border-radius: 0;
            flex: 1;
          }
          .searchinput{
            flex: 10;
            .el-input__inner{
              border-radius: 0;
              border-top: 1px solid #003f7f;
              border-bottom: 1px solid #003f7f;
            }
            .el-input__suffix{
              margin-top: -6px!important;
            }
          }
          .markSearchbtn{
            margin: 0!important;
            height: 30px;
            width: 100%!important;
            padding: 8px 5px!important;
            background: no-repeat;
            background-color: #003f7f;
            background-image: url('../../assets/mapicons/搜索白.png');
            background-position: 50% 50%;
            background-size: 80%;
            border-radius: 0;
            flex: 1;
          }
        }
        .filterForm{
          height: 60px;
          width: 100%;
          // border-top: 1px solid gainsboro;
          border-right: 1px solid gainsboro;
          // border-bottom: 1px solid gainsboro;
          border-left: 0;
          display: flex;
          .filterreset{
            width: 100%;
            height: 100%;
            text-align: center;
            flex: 1;
            .el-button--primary{
              border-radius: 0;
              height: 100%;
              width: 100%;
              margin: 0!important;
              padding: 0;
              background-color: #003f7f;
              font-weight: bold;
              p{
                line-height: 135%;
              }
            }
          }
          .filtercolor{
            width: 100%;
            height: 100%;
            background: no-repeat;
            background-position: 50% 50%;
            background-size: 75%;
            flex: 1;
          }
          .filtercolor:hover{
            background-color: #f0f0f0;
          }
          .filtercolord{
            width: 100%;
            height: 100%;
            background: no-repeat;
            background-position: 50% 50%;
            background-size: 75%;
            background-color: #f0f0f0;
            flex: 1;
          }
          #filterblue{
            background-image: url('../../assets/mapicons/mapiconblue.png');
          }
          #filtergreen{
            background-image: url('../../assets/mapicons/mapicongreen.png');
          }
          #filteryellow{
            background-image: url('../../assets/mapicons/mapiconyellow.png');
          }
          #filterred{
            background-image: url('../../assets/mapicons/mapiconred.png');
          }
          #filterblack{
            background-image: url('../../assets/mapicons/mapiconblack.png');
          }
        }
      }
      .mlDefault{
        height: calc(100vh - 146px);
      }
      .mlShowFilter{
        height: calc(100vh - 206px);
        // height: 465px;
      }
      .mlFullScreen{
        height: calc(100vh - 106px);
      }
      .mlFullScreenShowFilter{
        height: calc(100vh - 166px);
        // height: 465px;
      }
      .markList{
        display: flex;
        flex-direction:  column;
        border: 1px solid gainsboro;
        overflow: hidden;
        // height: 527px;
        overflow-y: auto;
        .markCard-areaIntros{
          width: 100%;
          overflow: hidden;
          cursor: pointer;
          display: block;
          border: 1px solid gainsboro;
          background-color: #ffffff;
        }
        .markCard-monitors{
          width: 100%;
          overflow-y: visible;
          cursor: pointer;
          display: block;
          border: 1px solid gainsboro;
          background-color: #ffffff;
          .markerVideoPlayer{
            width: 100%;
            padding-bottom: 0;
            .myMntVideoUdf{
              width: 100%;
              font-size: 14px;
              text-align: center;
              height: 36px;
              font-weight: bold;
              line-height: 36px;
              background-color: #ccc;
            }
            .no-video{
              display: flex;
              height: 100%;
              font-size: 14px;
              text-align: center;
              justify-content: center;
              align-items: center;
            }
            // video::-webkit-media-controls-fullscreen-button {
            //   display: none;
            // }
            video::-webkit-media-controls-play-button {
              display: none;
            }
            video::-webkit-media-controls-timeline {
              display: none;
            }
            video::-webkit-media-controls-current-time-display {
              display: none;
            }
            video::-webkit-media-controls-time-remaining-display {
              display: none;
            }
            // video::-webkit-media-controls-mute-button {
            //   display: none;
            // }
            // video::-webkit-media-controls-toggle-closed-captions-button {
            //   display: none;
            // }
            // video::-webkit-media-controls-volume-slider {
            //   display: none;
            // }
            .myMntVideo {
              object-fit: fill;
              width: 100%;
              margin-bottom: 0;
            }
            // /deep/ .video-js .vjs-tech {
            // object-fit: contain;
            // }
            // .video-js .vjs-big-play-button{
            //   /*对播放按钮的样式进行设置*/
            //   width: 100%;
            //   height: 100%;
            //   border-radius: 50%;
            // }
          }
        }
        .markerData{
          margin: 5px;
          display: flex;
          .markerType{
            margin: auto;
            vertical-align: middle;
            text-align: center;
            width: 80%;
            height: 60px;
            background: no-repeat;
            background-position: 50% 50%;
            background-size: 100%;
          }
          .markerType-monitor{
            margin: auto;
            vertical-align: middle;
            text-align: center;
            width: 80%;
            height: 30px;
            background: no-repeat;
            background-position: 50% 50%;
            background-size: 100%;
          }
          .mapiconblack{
            background-image: url('../../assets/mapicons/mapiconblack.png');
          }
          .mapicongreen{
            background-image: url('../../assets/mapicons/mapicongreen.png');
          }
          .mapiconyellow{
            background-image: url('../../assets/mapicons/mapiconyellow.png');
          }
          .mapiconred{
            background-image: url('../../assets/mapicons/mapiconred.png');
          }
          .mapiconblue{
            background-image: url('../../assets/mapicons/mapiconblue.png');
          }
          .atmosiconblack{
            background-image: url('../../assets/mapicons/atmosiconblack.png');
          }
          .atmosicongreen{
            background-image: url('../../assets/mapicons/atmosicongreen.png');
          }
          .atmosiconyellow{
            background-image: url('../../assets/mapicons/atmosiconyellow.png');
          }
          .atmosiconred{
            background-image: url('../../assets/mapicons/atmosiconred.png');
          }
          .atmosiconblue{
            background-image: url('../../assets/mapicons/atmosiconblue.png');
          }
          .watericonblack{
            background-image: url('../../assets/mapicons/watericonblack.png');
          }
          .watericongreen{
            background-image: url('../../assets/mapicons/watericongreen.png');
          }
          .watericonyellow{
            background-image: url('../../assets/mapicons/watericonyellow.png');
          }
          .watericonred{
            background-image: url('../../assets/mapicons/watericonred.png');
          }
          .watericonblue{
            background-image: url('../../assets/mapicons/watericonblue.png');
          }
          .uelectroiconblack{
            background-image: url('../../assets/mapicons/uelectroiconblack.png');
          }
          .uelectroicongreen{
            background-image: url('../../assets/mapicons/uelectroicongreen.png');
          }
          .uelectroiconyellow{
            background-image: url('../../assets/mapicons/uelectroiconyellow.png');
          }
          .uelectroiconred{
            background-image: url('../../assets/mapicons/uelectroiconred.png');
          }
          .uelectroiconblue{
            background-image: url('../../assets/mapicons/uelectroiconblue.png');
          }
          .uwatericonblack{
            background-image: url('../../assets/mapicons/uwatericonblack.png');
          }
          .uwatericongreen{
            background-image: url('../../assets/mapicons/uwatericongreen.png');
          }
          .uwatericonyellow{
            background-image: url('../../assets/mapicons/uwatericonyellow.png');
          }
          .uwatericonred{
            background-image: url('../../assets/mapicons/uwatericonred.png');
          }
          .uwatericonblue{
            background-image: url('../../assets/mapicons/uwatericonblue.png');
          }
          .markerMarker{
            height: 60px;
            line-height: 60px;
            text-align: center;
            flex: 1;
          }
          .markerMarker-monitor{
            height: 30px;
            line-height: 60px;
            text-align: center;
            flex: 1;
          }
          .markerMain{
            flex: 5;
          }
          .markerMain-monitor{
            flex: 10;
          }
          .markerName{
            height: 30px;
            line-height: 30px;
            font-size: 18px;
            margin-right: 5px;
            font-weight: bold;
          }
          .markerOthers{
            height: 30px;
            line-height: 30px;
            display: flex;
            .markerTime{
              text-align: left;
              font-size: 12px;
              flex: 1;
            }
            .markerTarget{
              text-align: right;
              font-size: 12px;
              flex: 1;
            }
          }
        }
      }
    }
    .amapContainer{
      width: 800px;
      height: 600px;
      border-top: 5px solid #003f7f;
      border-bottom: 5px solid #003f7f;
      border-left: 0;
      border-right: 0;
      flex: 1;
    }
    .amap-maptypecontrol{
      top: calc(100% - 114px);
      right: 10px;
    }
    .amap-scalecontrol{
      left: 50px!important;
      bottom: 20px;
      visibility: visible;
    }
    .toolbtn {
      margin: 0;
      height: calc(100vh - 80px);
      line-height: 25px;
      color: white!important;
      font-weight: bold;
      font-size: 18px;
      background-color: #003f7f;
      border-radius: 0 4px 4px 0;
      padding: 250px 10px;
      text-decoration: none;
      cursor: pointer;
    }
    .toolbtnc {
      display: none;
    }
    .leftdiv {
      float: right;
      width: 184px;
      margin-right: -184px;
      height: 100%;
      overflow: hidden;
      transition: 0.1s all;
      flex: none;
    }
    .leftside {
      margin-right: 0;
      float: right;
      width: 184px;
      height: 100%;
      overflow: hidden;
      transition: 0.1s all;
      flex: none;
    }
    .arcgis-map-div{
      // display: flex;
      width: 100%;
      height: calc(100vh - 80px);
      .arcgis-map{
        height: 100%;
        width: 100%;
        // border: 4px solid #008888;
        .esri-view-root{
          .esri-ui{
            .esri-ui-inner-container{
              .esri-ui-top-left{
                .esri-search{
                  margin-bottom: -32px;
                  margin-left : 42px;
                }
                .esri-navigation-toggle{
                  margin-top: -74px;
                  margin-left: 42px;
                }
              }
              .esri-ui-bottom-left{
                .esri-time-slider{
                  width: 40vw;
                  .esri-time-slider__row{
                    height: 32px;
                    .esri-time-slider__animation,
                    .esri-time-slider__previous,
                    .esri-time-slider__next{
                      width: 32px;
                    }
                    .esri-time-slider__time-extent{
                      width: 160px;
                    }
                    .esri-time-slider__min,
                    .esri-time-slider__max{
                      width: 0;
                    }
                    .esri-time-slider__slider{
                      padding: 6px 16px;
                      .esri-slider{
                        margin: 0;
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  .esri-sketch{
    margin-right: 44px;
    margin-top: -116px;
    .esri-sketch__section{
      padding: 0;
      margin: 0;
    }
  }
  .measurementBar{
    background: #fff;
    .action-button {
      font-size: 16px;
      background-color: transparent;
      border: 0 solid #d3d3d3;
      color: #6e6e6e;
      height: 32px;
      width: 32px;
      text-align: center;
      box-shadow: 0 0 1px rgba(0, 0, 0, 0.3);
    }
    .action-button:hover,
    .action-button:focus {
      background: #007fff;
      color: #e4e4e4;
    }
    .action-button.active {
      background: #007fff;
      color: #e4e4e4;
    }
  }
  .provinceList{
    width: 160px;
    select{
      width: 100%;
      height: 32px;
      padding: 4px;
      font-size: 16px;
    }
    .el-input{
      .el-input__inner{
        height: 32px!important;
        font-size: 16px;
        border-radius: 0!important;
        text-align: center;
        padding: 0;
      }
      .el-input__suffix{
        display: none;
      }
    }
  }
  .nut-dialog{
    .nut-textinput{
      margin-bottom: 8px;
      .nut-textinput-label {
        text-align: left;
        width: 58px;
      }
    }
    .longSelect{
      height: 40px;
      width: calc(100% - 60px);
      margin-bottom: 8px;
      padding: 4px;
      border-radius: 4px!important;
      border-color: #dddfe6!important;
    }
  }
}
</style>
